webpackJsonp([1],{

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAuth_vue__ = __webpack_require__(490);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d6df7b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAuth_vue__ = __webpack_require__(640);
function injectStyle (ssrContext) {
  __webpack_require__(639)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAuth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d6df7b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAuth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logoLogin.3212e38.png";

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccueilComponent',
  data: function data() {
    return {};
  },

  methods: {},
  computed: {}
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailEchantillonComponent__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderSearchComponent__ = __webpack_require__(484);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewEnregistrementComponent',
  components: {
    DetailEchantillonComponent: __WEBPACK_IMPORTED_MODULE_2__DetailEchantillonComponent__["a" /* default */], HeaderSearch: __WEBPACK_IMPORTED_MODULE_3__HeaderSearchComponent__["a" /* default */]
  },
  data: function data() {
    return {
      isSac: false,
      itemsAll: [],
      sacCustomerFilter: null,
      enregistrement: {},
      analyse: {},
      products: null,
      idFamily: 8,
      fields: [],
      items: [],
      oldCol: true,
      newCol: true,
      oldCol2: false,
      newCol2: false,
      index: 1,
      isBusy: true,
      perPage: 50,
      currentPage: 1,
      totalItems: 0,

      selected: 'dateDbtFin',
      tri: '',
      nbreJour: 30,
      jourDisabled: false,
      echantillonDisable: true,
      echantillonFilter: null,
      disableRadio: false,
      dateDisable: false,
      dateDebut: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(30, 'days').format('YYYY-MM-DD'),
      dateFin: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
      dateMax: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
      isHide: true,
      select: false,

      modeEdition: 'create',
      itemEdit: null,
      itemToDelete: null,
      modalDeleteShown: false,
      msgsErrorDelete: [],
      msgSuccessDelete: ''
    };
  },

  methods: {
    hiddenModal: function hiddenModal() {
      var vm = this;

      vm.getEnregistrementByClient();
    },
    hideModel: function hideModel() {
      this.$refs['my-modal'].hide();
    },
    getResultsForRangeDates: function getResultsForRangeDates() {
      var _this = this;

      setTimeout(function () {
        _this.getEnregistrementByClient();
      }, 0);
    },
    getProduct: function getProduct() {
      this.isBusy = true;
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getProductsByClient(this.$root.user.login).done(function (data) {
        vm.products = data.products;
      }).fail(function (xhr) {
        window.fail(xhr, true);
      }).always(function () {
        vm.isBusy = false;
      });
    },
    getProductsGenerik: function getProductsGenerik() {
      this.isBusy = true;
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getProductsGenerikByClient(this.$root.user.login).done(function (data) {
        vm.products = data.products;
      }).fail(function (xhr) {
        window.fail(xhr, true);
      }).always(function (xhr) {
        vm.isBusy = true;
      });
    },
    onSacCustomerSelected: function onSacCustomerSelected(value) {
      this.sacCustomerFilter = value;

      this.currentPage = 1;

      this.applySacFilter(true);
    },
    applySacFilter: function applySacFilter() {
      var resetPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.isSac) {
        this.items = Array.isArray(this.itemsAll) ? this.itemsAll.slice() : [];
        this.totalItems = Array.isArray(this.itemsAll) ? this.itemsAll.length : 0;
        return;
      }

      var filtered = this.itemsAll || [];
      if (this.sacCustomerFilter) {
        var filterVal = this.sacCustomerFilter;
        filtered = filtered.filter(function (item) {
          return item.CENT_CLT && String(item.CENT_CLT) === String(filterVal) || item.CLT_NUM && String(item.CLT_NUM) === String(filterVal) || item.CENT_NUM && String(item.CENT_NUM) === String(filterVal);
        });
      }

      this.totalItems = filtered.length;

      if (resetPage) {
        this.currentPage = 1;
      }

      var perPage = this.perPage || 50;
      var start = (this.currentPage - 1) * perPage;
      var end = start + perPage;
      this.items = filtered.slice(start, end);
    },
    getFamilyByClient: function getFamilyByClient() {
      this.isBusy = true;
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getFamilyByClient(this.$root.user.login).done(function (data) {
        vm.products = data.products;
      }).fail(function (xhr) {
        window.fail(xhr, true);
      }).always(function (xhr) {
        vm.isBusy = true;
      });
    },
    getEnregistrementByClient: function getEnregistrementByClient() {
      var vm = this;

      vm.isBusy = true;
      var select = vm.select === false ? 0 : 1;

      var reqPage = vm.isSac ? 1 : vm.currentPage;
      var reqLimite = vm.isSac ? 1000000 : vm.perPage;
      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getEnregistrementByClient(vm.$root.user.login, vm.dateDbt, vm.dateFin, select, reqPage, reqLimite).done(function (data) {
        vm.itemsAll = data.enregistrements || [];

        if (vm.isSac && Array.isArray(vm.itemsAll)) {
          vm.itemsAll.sort(function (a, b) {
            var rsoA = a && a.CENT_RSO ? String(a.CENT_RSO) : '';
            var rsoB = b && b.CENT_RSO ? String(b.CENT_RSO) : '';
            if (rsoA !== rsoB) return rsoA.localeCompare(rsoB, 'fr', { sensitivity: 'base' });
            var libA = a && a.CENT_LIB ? String(a.CENT_LIB) : '';
            var libB = b && b.CENT_LIB ? String(b.CENT_LIB) : '';
            return libA.localeCompare(libB, 'fr', { sensitivity: 'base' });
          });
        }

        vm.applySacFilter(true);

        vm.totalItems = data.total;
      }).fail(function (xhr) {
        window.fail(xhr, true);
      }).always(function () {
        vm.isBusy = false;
      });
    },
    displayTable: function displayTable() {
      if (this.isSac) {
        this.fields = [{
          key: 'NEWCOLUMN',
          label: '',
          sortable: false
        }, {
          key: 'CENT_CECH',
          label: 'Code Echantillon',
          sortable: false
        }, {
          key: 'CENT_RSO',
          label: 'Client',
          sortable: false
        }, {
          key: 'CENT_LIB',
          label: 'Produit',
          sortable: false
        }, {
          key: 'CENT_NRAP',
          label: 'Numéro de rapport ',
          sortable: false
        }, {
          key: 'CENT_FAM.CFAM_LIB',
          label: 'Famille',
          sortable: false
        }, {
          key: 'CENT_TYP',
          label: 'Type Analyse',
          sortable: false
        }, {
          key: 'CENT_NBJ',
          label: 'Analyse à J+',
          sortable: false
        }, {
          key: 'CENT_DATPRLT',
          label: 'Date prélèvement',
          sortable: false
        }, {
          key: 'CENT_DATDLC',
          label: 'DLC',
          sortable: false
        }, {
          key: 'CENT_DATFAB',
          label: 'Date Fabrication',
          sortable: false
        }, {
          key: 'CENT_DATSOUHAIT',
          label: 'Date Dispo Labo',
          sortable: false
        }, {
          key: 'EDIT',
          label: 'Modifier',
          sortable: false
        }, {
          key: 'DELETE',
          label: 'Effacer',
          sortable: false
        }];
      } else {
        this.fields = [{
          key: 'NEWCOLUMN',
          label: '',
          sortable: false
        }, {
          key: 'CENT_CECH',
          label: 'Code Echantillon',
          sortable: false
        }, {
          key: 'CENT_LIB',
          label: 'Produit',
          sortable: false
        }, {
          key: 'CENT_NRAP',
          label: 'Numéro de rapport ',
          sortable: false
        }, {
          key: 'CENT_FAM.CFAM_LIB',
          label: 'Famille',
          sortable: false
        }, {
          key: 'CENT_TXT3',
          label: 'N° Lot',
          sortable: false
        }, {
          key: 'CENT_COD_CLT',
          label: 'Code Produit',
          sortable: false
        }, {
          key: 'CENT_TXT1',
          label: 'Ref Client',
          sortable: false
        }, {
          key: 'CENT_TXT2',
          label: 'Ref Fournisseur',
          sortable: false
        }, {
          key: 'CENT_TYP',
          label: 'Type Analyse',
          sortable: false
        }, {
          key: 'CENT_NBJ',
          label: 'Analyse à J+',
          sortable: false
        }, {
          key: 'CENT_DATPRLT',
          label: 'Date prélèvement',
          sortable: false
        }, {
          key: 'CENT_DATDLC',
          label: 'DLC',
          sortable: false
        }, {
          key: 'CENT_DATFAB',
          label: 'Date Fabrication',
          sortable: false
        }, {
          key: 'CENT_DATSOUHAIT',
          label: 'Date Dispo Labo',
          sortable: false
        }, {
          key: 'EDIT',
          label: 'Modifier',
          sortable: false
        }, {
          key: 'DELETE',
          label: 'Effacer',
          sortable: false
        }];
      }
    },
    addRow: function addRow(index, item) {
      this.oldCol = true;
      this.newCol = false;
      this.oldCol2 = false;
      this.newCol2 = true;
      this.index = this.index + 1;
    },
    showModalInfoEchantillon: function showModalInfoEchantillon() {
      this.$refs['modalInfoEchantillon'].show();
    },
    deleteEchantillon: function deleteEchantillon() {
      var _this2 = this;

      var date = this.itemToDelete.CENT_ANN + '-' + this.itemToDelete.CENT_MOI + '-' + this.itemToDelete.CENT_JOU;
      if (this.$root.user.login === 907 || this.$root.user.login === 9999) {
        __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].deleteEchantillonSac(date, this.itemToDelete.CENT_NUM, this.itemToDelete.CENT_CLT).done(function (data) {
          _this2.msgsErrorDelete = [];
          _this2.msgSuccessDelete = 'L\'analyse a bien été supprimée';
          setTimeout(function () {
            _this2.msgSuccessDelete = '';
            _this2.modalDeleteShown = false;
            _this2.getEnregistrementByClient();
          }, 2000);
        }).fail(function (xhr) {
          _this2.msgsErrorDelete = xhr.responseJSON.erreurs;
          _this2.msgSuccessDelete = '';
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].deleteEchantillon(date, this.itemToDelete.CENT_NUM).done(function (data) {
          _this2.msgsErrorDelete = [];
          _this2.msgSuccessDelete = 'L\'analyse a bien été supprimée';
          setTimeout(function () {
            _this2.msgSuccessDelete = '';
            _this2.modalDeleteShown = false;
            _this2.getEnregistrementByClient();
          }, 2000);
        }).fail(function (xhr) {
          _this2.msgsErrorDelete = xhr.responseJSON.erreurs;
          _this2.msgSuccessDelete = '';
        });
      }
    },
    showModal: function showModal(modeEdition, data) {
      this.modeEdition = modeEdition;
      this.itemEdit = data != null ? data.item : null;
      this.$refs['my-modal'].show();
    },
    hideModal: function hideModal(enregistrement) {
      this.$refs['my-modal'].hide();
      this.items.push(enregistrement);
    },
    runExport: function runExport() {
      var _this3 = this;

      var s = this.select === true ? 1 : 0;
      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getEnregistrementByClient(this.$root.user.login, this.dateDbt, this.dateFin, s, 1, 50, 'csv').done(function (data) {
        _this3.downloadFile(data, 'demandesAnalyses');
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    downloadFile: function downloadFile(csv, fileName) {
      var blob = new Blob(['\uFEFF', csv]);
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName + '.csv');
      document.body.appendChild(link);
      link.click();
    },
    showModalDelete: function showModalDelete(data) {
      this.itemToDelete = data.item;
      this.modalDeleteShown = true;
      this.msgsErrorDelete = [];
      this.msgSuccessDelete = '';
    }
  },
  created: function created(params) {
    this.isSac = this.$root.user.login === 907 || this.$root.user.login === 9999;
    this.getEnregistrementByClient();
    this.displayTable();
  },
  mounted: function mounted(data) {
    global.model1 = this.$refs['my-modal'];
    this.items = [{
      ECHANTILLON: ''
    }];
  },
  watch: {
    selected: function selected() {
      if (this.selected !== 'echantillon') {
        this.echantillonDisable = true;
        this.isHide = false;
      } else {
        this.echantillonDisable = false;
      }

      if (this.selected !== 'dateDbtFin') {
        this.dateDisable = true;
        this.isHide = true;
      } else {
        this.dateDisable = false;
      }
    },
    currentPage: function currentPage() {
      if (this.isSac) {
        this.applySacFilter(false);
      } else {
        this.getResultsForRangeDates();
      }
    }
  },
  computed: {
    dateDbt: function dateDbt() {
      if (this.dateDebut === '') {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(this.nbreJour, 'days').format('YYYY-MM-DD');
      } else {
        return this.dateDebut;
      }
    },
    titleModalForm: function titleModalForm() {
      return this.modeEdition === 'create' ? 'Demande d\'analyse : nouvel échantillon' : 'Demande d\'analyse : modification échantillon';
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(50)))

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailEchantillonComponent_vue__ = __webpack_require__(462);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c3db3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailEchantillonComponent_vue__ = __webpack_require__(622);
function injectStyle (ssrContext) {
  __webpack_require__(549)
  __webpack_require__(550)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailEchantillonComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c3db3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailEchantillonComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SelectedAnalysesComponent_vue__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConfirmationEchantillonComponent_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CommentaireLabo_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DetailEchantillonComponent',
  props: ['modeEdition', 'itemEdit', 'numRapport'],
  data: function data() {
    return {
      validator: {
        'CENT_CLT': null,
        'CENT_LIB': null,
        'CENT_PRD': null,
        'CENT_FAM': null,
        'CENT_DATPRLT': null,
        'CENT_DATSOUHAIT': null,
        'CENT_NBJ': null,
        'CENT_DATDLC': null,
        'CENT_DATFAB': null
      },
      changeClient: false,
      isSac: this.$root.user.login === 907 || this.$root.user.login === 9999,
      clients: [],
      selectedClient: null,
      clientSelected: null,
      checksChamp: ['CENT_LIB', 'CENT_CLT', 'CENT_PRD', 'CENT_FAM', 'CENT_DATPRLT', 'CENT_DATSOUHAIT', 'CENT_NBJ', 'CENT_DATDLC'],
      productPreSelected: null,
      productDataSelected: '',
      checkedEchantillonMoyen: false,
      checked1RapportEch: false,
      numRapportSelected: null,
      listNumRapport: [],
      canAddClient: true,
      canAddFournisseur: true,
      productsForEchantillon: [],
      familiesForEchantillon: [],
      libelleEchantillon: [],
      enregistrement: {},
      enregistrements: [],
      itemsAnalyse: [],
      analyse: {},
      analysePreSelected: null,
      analysesList: [],
      analysesListSelected: [],
      analysesSelected: [],
      overlayAnalysesSelected: false,
      serieAnalysesSelected: [],
      products: [],
      seriesAnalyses: [],
      selected: {
        analyses: [],
        seriesAnalyses: [],
        analysesSelected: []
      },
      idFamily: 8,
      familyDataPreSelected: null,
      typeAnalysePreSelected: { value: 1, lib: 'jour' },
      families: [],
      filter: null,
      loading: true,
      filterSelected: null,
      echantillonNum: null,
      valid: false,
      nbEchantillonSimilaires: 1,
      typesAnalyses: [{ value: 1, lib: 'jour' }, { value: 2, lib: 'DLC' }, { value: 3, lib: 'J+' }],
      recapEnregistrement: [],
      itemsRefClient: [],
      itemsRefFournisseur: [],
      middleEchantillon: false,
      nbRequestRecord: 0,
      close: false,
      fields: [{
        key: 'ANA_NUM',
        label: 'Ref'
      }, {
        key: 'ANA_LIB',
        label: ''
      }],
      fieldsSeriesAnalyses: [{
        key: 'SER_LIB',
        label: 'S\xE9rie d\'analyses'
      }],
      analysesMoyenSelected: []
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard__["TabContent"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default.a,
    SelectedAnalysesComponent: __WEBPACK_IMPORTED_MODULE_11__SelectedAnalysesComponent_vue__["a" /* default */],
    CommentaireLabo: __WEBPACK_IMPORTED_MODULE_13__CommentaireLabo_vue__["a" /* default */],
    ConfirmationEchantillonComponent: __WEBPACK_IMPORTED_MODULE_12__ConfirmationEchantillonComponent_vue__["a" /* default */]
  },
  mounted: function mounted() {
    var vm = this;

    vm.loading = true;

    if (vm.$root.user.COR_WEB_CLT === 1) {
      vm.canAddClient = true;
    }
    if (vm.$root.user.COR_WEB_FRS === 1) {
      vm.canAddFournisseur = true;
    }

    if (vm.isSac) {
      __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getAllSacCustomers().done(function (data) {
        vm.clients = data.customers.map(function (client) {
          return {
            login: client.CLT_NUM,
            fullName: client.CLT_RSO
          };
        });

        var lastCustomer = sessionStorage.getItem('lastCustomer');
        if (lastCustomer) {
          try {
            var parsedLastCustomer = JSON.parse(lastCustomer);

            var clientIndex = vm.clients.findIndex(function (client) {
              return client.login === parsedLastCustomer.login;
            });
            if (clientIndex > -1) {
              var client = vm.clients.splice(clientIndex, 1)[0];

              vm.clients.unshift(client);
            }
          } catch (e) {
            console.warn('Erreur lors de la récupération du dernier client:', e);
          }
        }
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    }

    var requests = [];
    requests.push(__WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getProductsGenerikByClient(vm.$root.user.login).done(function (data) {
      var pData = data.productsGenerik;
      pData.forEach(function (element) {
        var dObject = {
          CWL_FAM: element.CWL_FAM,
          CWL_PDT: element.CWL_PDT,
          fullName: element.CWL_NUM + ' ' + element.CWL_LIB.trim(),
          CWL_NUM: element.CWL_NUM,
          CWL_LIB: element.CWL_LIB.trim(),
          ID_ANALYSES: element.ID_ANALYSES,
          nbrEchantillon: ''
        };
        vm.libelleEchantillon.push(dObject);
      });
    }).fail(function (xhr) {
      window.fail(xhr, true);
    }));

    requests.push(__WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getFamilyByClient(vm.$root.user.login).done(function (data) {
      var pData = data.family;
      pData.forEach(function (element) {
        var dObject = {
          fullName: element.CFAM_LIB,
          CFAM_FAM: element.CFAM_FAM,
          CFAM_LIB: element.CFAM_LIB
        };
        vm.families.push(dObject);
        vm.familiesForEchantillon = vm.families;
        vm.familiesForEchantillon.sort(function (a, b) {
          return a.CFAM_LIB - b.CFAM_LIB;
        });
      });
    }).fail(function (xhr) {
      window.fail(xhr, true);
    }));

    requests.push(__WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getProductsByClient(vm.$root.user.login).done(function (data) {
      var pData = data.products;
      pData.forEach(function (element) {
        var dObject = {
          fullName: element.CPRD_LIB,
          CPRD_PRD: element.CPRD_PRD,
          CPRD_LIB: element.CPRD_LIB,
          CPRD_CPRD: element.CPRD_CPRD
        };
        vm.products.push(dObject);
        vm.productsForEchantillon = vm.products;
        vm.productsForEchantillon.sort(function (a, b) {
          return a.CPRD_PRD - b.CPRD_PRD;
        });
      });
    }).fail(function (xhr) {
      window.fail(xhr, true);
    }));

    requests.push(__WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getRefClient().done(function (data) {
      vm.itemsRefClient = data.data;
    }).fail(function (xhr) {
      window.fail(xhr, true);
    }));

    requests.push(__WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getRefFournisseur().done(function (data) {
      vm.itemsRefFournisseur = data.data;
    }).fail(function (xhr) {
      window.fail(xhr, true);
    }));

    requests.push(vm.getAnalyses());

    requests.push(vm.getFinalListRapport());

    vm.clearForm();

    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.all(requests).then(function () {
      if (vm.itemEdit !== null) {
        vm.buildItemEdit();
      } else if (vm.isSac) {
        vm.preselectLastCustomer();
      }

      vm.loading = false;
    });
  },
  methods: {
    customLabel: function customLabel(option) {
      return option.fullName + ' (' + option.login + ')';
    },
    onClientSelected: function onClientSelected(selected) {
      if (selected) {
        this.clientSelected = selected.login;
        this.getSacData();
      } else {
        this.clientSelected = null;
      }
    },
    preselectLastCustomer: function preselectLastCustomer() {
      var vm = this;
      var lastCustomer = sessionStorage.getItem('lastCustomer');
      if (lastCustomer) {
        try {
          var parsedLastCustomer = JSON.parse(lastCustomer);

          var client = vm.clients.find(function (client) {
            return client.login === parsedLastCustomer.login;
          });
          if (client) {
            vm.selectedClient = client;
            vm.onClientSelected(client);
          }
        } catch (e) {
          console.warn('Erreur lors de la présélection du dernier client:', e);
        }
      }
    },
    getFinalListRapport: function getFinalListRapport() {
      var vm = this;
      return __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getNummRapportClient().done(function (data) {
        vm.listNumRapport = data.data;
        if (vm.modeEdition === 'create') {
          setTimeout(function () {
            var max = Math.max.apply(Math, [0].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(vm.listNumRapport)));
            vm.listNumRapport.unshift(max + 1);
            vm.numRapportSelected = max + 1;
          }, 0);
        }
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    verifAndSetAnalyse: function verifAndSetAnalyse(prevIndex, nextIndex) {
      if (nextIndex === 1 && sessionStorage.getItem('analyses')) {
        this.analysesSelected = JSON.parse(sessionStorage.getItem('analyses'));
      }
      if (nextIndex === 2 && this.checkedEchantillonMoyen && sessionStorage.getItem('analysesMoyen')) {
        this.analysesMoyenSelected = JSON.parse(sessionStorage.getItem('analysesMoyen'));
      }
      if (this.$refs.commentaireLabo) {
        this.$refs.commentaireLabo.logFieldValues();
      }
    },
    autoCompleteForm: function autoCompleteForm() {
      var vm = this;

      vm.enregistrement.CENT_LIB = vm.analysePreSelected.trim();

      var product = vm.libelleEchantillon.find(function (lib) {
        return lib.fullName === vm.analysePreSelected;
      });

      if (!product) {
        product = vm.libelleEchantillon.find(function (lib) {
          return vm.analysePreSelected.startsWith(lib.CWL_NUM + ' ');
        });
      }

      if (product) {
        vm.productPreSelected = product;

        setTimeout(function () {
          vm.analysePreSelected = product.CWL_LIB;
        }, 0);

        vm.enregistrement.CENT_LIB = product.CWL_LIB;

        vm.productDataSelected = this.products.find(function (item) {
          return item.CPRD_PRD === product.CWL_PDT;
        });

        this.familyDataPreSelected = this.families.find(function (item) {
          return item.CFAM_FAM === product.CWL_FAM;
        });

        vm.preSelectCurrentAnalyse();
      }
    },
    checkStateModel: function checkStateModel(e) {
      if (e.target.value.length > 0) {
        return true;
      }
      return false;
    },
    postEnregistrementStorage: function postEnregistrementStorage() {
      var _this = this;

      if (this.modeEdition === 'edit') {
        this.productPreSelected.ID_ANALYSES = this.enregistrement.ANALYSES;
      }
      this.valid = true;
      this.checksChamp.forEach(function (chk) {
        if (!_this.enregistrement[chk] || _this.enregistrement[chk] === '') {
          _this.valid = false;
          _this.validator[chk] = false;
        } else {
          _this.validator[chk] = true;
        }

        if (_this.valid === false) {
          console.log('error on', chk);
        }
      });

      if (typeof this.enregistrement.CENT_DATPRLT === 'undefined' || __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.enregistrement.CENT_DATPRLT).isValid() === false) {
        this.valid = false;
        this.validator['CENT_DATPRLT'] = false;
      }

      if (typeof this.enregistrement.CENT_DATSOUHAIT === 'undefined' || __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.enregistrement.CENT_DATSOUHAIT).isValid() === false) {
        this.valid = false;
        this.validator['CENT_DATSOUHAIT'] = false;
      }

      if (this.enregistrement.CENT_TYP === 2 && (typeof this.enregistrement.CENT_DATDLC === 'undefined' || __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.enregistrement.CENT_DATDLC).isValid() === false)) {
        this.valid = false;
        this.validator['CENT_DATDLC'] = false;
      }

      if (!this.isSac) {
        this.valid = true;
        this.validator['CENT_CLT'] = true;
        this.clientSelected = this.$root.user.login;
      } else if (!this.clientSelected) {
        this.valid = false;
        this.validator['CENT_CLT'] = false;
      } else {
        this.validator['CENT_CLT'] = true;
      }

      this.validator['CENT_DATFAB'] = null;
      if (this.enregistrement.CENT_TYP === 3) {
        if (typeof this.enregistrement.CENT_NBJ === 'undefined' || this.enregistrement.CENT_NBJ === '') {
          this.valid = false;
          this.validator['CENT_NBJ'] = false;
        }

        if (!this.enregistrement.CENT_DATFAB || this.enregistrement.CENT_DATFAB === '') {
          this.valid = false;
          this.validator['CENT_DATFAB'] = false;
        } else {
          this.validator['CENT_DATFAB'] = true;
        }
      }
      if (this.valid === true) {
        if (this.isSac) {
          this.enregistrement.idClient = this.clientSelected;
        } else {
          this.enregistrement.idClient = this.$root.user.login;
        }
        this.enregistrement.fullNameProduct = this.productDataSelected.fullName;
        this.enregistrement.fullNameFamily = this.familyDataPreSelected.fullName;
        sessionStorage.setItem('enregistrement', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(this.enregistrement));
        this.enregistrements.push(this.enregistrement);
        return true;
      } else {
        return false;
      }
    },
    postEnregistrementBddAsync: function postEnregistrementBddAsync() {
      var typeAnalyse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'analyses';

      var _this2 = this;

      var skipAnalyses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var forceCreate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve) {
        var vm = _this2;
        var apiMethod = __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].putEnregistrement;
        if (vm.modeEdition === 'create' || forceCreate) {
          apiMethod = __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].postEnregistrement;
        }
        vm.nbRequestRecord++;

        var payload = JSON.parse(sessionStorage.getItem('enregistrement'));

        payload = _this2.prepareCommentFieldsForSubmission(payload);

        if (typeAnalyse === 'analysesMoyen' && payload && Object.prototype.hasOwnProperty.call(payload, 'CENT_FORFAIT')) {
          delete payload.CENT_FORFAIT;
        }
        apiMethod(payload).done(function (data) {
          if (data && data.echantillonNum) {
            vm.echantillonNum = data.echantillonNum;
          }

          if (!skipAnalyses) {
            vm.postAnalyseBdd(typeAnalyse);
          }
          resolve();
        }).fail(function (xhr) {
          window.fail(xhr, true);
          vm.close = false;
          resolve();
        }).always(function () {
          vm.nbRequestRecord--;
        });
      });
    },
    postAnalyseStorage: function postAnalyseStorage() {
      if (this.analysesSelected.length === 0 && this.overlayAnalysesSelected === false) {
        this.overlayAnalysesSelected = true;

        return false;
      }
      this.recapEnregistrement = [];
      sessionStorage.setItem('analyses', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(this.analysesSelected));
      var enr = JSON.parse(sessionStorage.getItem('enregistrement'));
      for (var i = 1; i <= this.nbEchantillonSimilaires; i++) {
        var libelleTo = enr.CENT_LIB;
        if (this.nbEchantillonSimilaires > 1) {
          libelleTo = enr.CENT_LIB + ' n° ' + i;
        }
        if (this.modeEdition === 'edit') {
          libelleTo = enr.CENT_LIB;
        }
        var recap = {
          indexRecap: i,
          isMoyen: false,
          libelle: libelleTo,
          analyses: this.analysesSelected
        };
        this.$set(this.recapEnregistrement, i, recap);
      }

      return true;
    },

    overlayAnalysesSelectedCancel: function overlayAnalysesSelectedCancel() {
      var vm = this;

      vm.overlayAnalysesSelected = false;
    },
    overlayAnalysesSelectedOk: function overlayAnalysesSelectedOk() {
      var vm = this;

      vm.$refs.stepWizard.nextTab();

      vm.overlayAnalysesSelected = false;
    },
    postAnalyseMoyenStorage: function postAnalyseMoyenStorage() {
      if (this.analysesMoyenSelected.length === 0 && this.overlayAnalysesSelected === false) {
        this.overlayAnalysesSelected = true;
        return false;
      }
      sessionStorage.setItem('analysesMoyen', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(this.analysesMoyenSelected));
      var enr = JSON.parse(sessionStorage.getItem('enregistrement'));
      var recap = {
        indexRecap: null,
        isMoyen: true,
        libelle: enr.CENT_LIB + ' - EM',
        analyses: this.analysesMoyenSelected
      };
      if (this.recapEnregistrement[this.nbEchantillonSimilaires + 1]) {
        this.$set(this.recapEnregistrement, this.nbEchantillonSimilaires + 1, recap);
      } else {
        this.recapEnregistrement.push(recap);
      }
      return true;
    },
    postAnalyseBdd: function postAnalyseBdd() {
      var typeAna = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'analyses';

      var vm = this;
      var enregistrement = JSON.parse(sessionStorage.getItem('enregistrement'));
      var analyses = JSON.parse(sessionStorage.getItem(typeAna));

      analyses.forEach(function (analyse) {
        if (vm.isSac) {
          vm.analyse.idCustomer = vm.clientSelected;
        } else {
          vm.analyse.idCustomer = vm.$root.user.login;
        }
        vm.analyse.numSample = vm.echantillonNum;
        vm.analyse.idAnalysis = analyse.ANA_NUM;
        if ('CENT_RECORD' in enregistrement && enregistrement.CENT_RECORD !== null) {
          vm.analyse.dateRecord = enregistrement.CENT_RECORD;
        }
        vm.nbRequestRecord++;
        __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].postAnalyse({
          data: vm.analyse
        }).always(function () {
          vm.nbRequestRecord--;
        });
      });
    },
    getSacSeriesAnalyses: function getSacSeriesAnalyses(userLogin, family) {
      var vm = this;
      return __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getSeriesAnalysesSac(userLogin, family).done(function (data) {
        var allIds = [];
        data.data.forEach(function (serie) {
          if (Array.isArray(serie.ID_ANALYSES)) {
            allIds = allIds.concat(serie.ID_ANALYSES);
          }
        });
        allIds = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(allIds)));
        var analysesForTous = vm.analysesList.filter(function (ana) {
          return allIds.includes(ana.ANA_NUM);
        });
        var series = [];
        if (analysesForTous.length > 0) {
          series.push({ SER_NUM: 0, SER_LIB: 'Tous', ID_ANALYSES: allIds, analyses: analysesForTous });
        }

        data.data.map(function (serie) {
          serie.analyses = vm.analysesList.filter(function (ana) {
            return serie.ID_ANALYSES.indexOf(ana.ANA_NUM) !== -1;
          });
        });
        vm.seriesAnalyses = series.concat(data.data);
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    getSeriesAnalyses: function getSeriesAnalyses() {
      var vm = this;
      return __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getSeriesAnalyses().done(function (data) {
        vm.seriesAnalyses = [{ SER_NUM: 0, SER_LIB: 'Tous', analyses: [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(vm.analysesList)) }];

        data.data.map(function (serie) {
          serie.analyses = vm.analysesList.filter(function (ana) {
            return serie.ID_ANALYSES.indexOf(ana.ANA_NUM) !== -1;
          });
        });
        vm.seriesAnalyses = vm.seriesAnalyses.concat(data.data);
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    getAnalyses: function getAnalyses() {
      var vm = this;

      return __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getAnalysesByClient().done(function (data) {
        if (data.analyses.length) {
          vm.analysesList = data.analyses;
          if (!vm.isSac) {
            vm.getSeriesAnalyses();
          }
        }
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    confirmation: function confirmation() {
      var vm = this;

      var nbrEchanTotal = vm.nbEchantillonSimilaires;
      if (nbrEchanTotal < 1) {
        return;
      }

      if (vm.checkedEchantillonMoyen) {
        nbrEchanTotal++;
      }

      vm.loadingRecord = true;

      vm.close = true;
      var preleveurAjoute = false;

      var isSimpleEdit = vm.modeEdition === 'edit' && vm.isSac && vm.nbEchantillonSimilaires === 1;
      var isEditWithAdditions = vm.modeEdition === 'edit' && vm.isSac && vm.nbEchantillonSimilaires > 1;

      var tasks = [];
      for (var i = 1; i <= nbrEchanTotal; i++) {
        tasks.push({ index: i, nbrEchanTotal: nbrEchanTotal });
      }

      var promise = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.resolve();
      tasks.forEach(function (task) {
        var i = task.index;
        promise = promise.then(function () {
          return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve) {
            var enregistrement = {};
            if (sessionStorage.getItem('enregistrement')) {
              enregistrement = JSON.parse(sessionStorage.getItem('enregistrement'));
            }
            enregistrement.CENT_LIB = vm.recapEnregistrement[i].libelle;
            if (vm.recapEnregistrement[i].commentaire !== null && vm.recapEnregistrement[i].commentaire !== '' && vm.recapEnregistrement[i].commentaire !== undefined) {
              if (enregistrement.CENT_COMMENT_APPLI_LABO) {
                enregistrement.CENT_COMMENT_APPLI_LABO += ' |Commentaire : ' + vm.recapEnregistrement[i].commentaire;
              } else {
                enregistrement.CENT_COMMENT_APPLI_LABO = vm.recapEnregistrement[i].commentaire;
              }
            }

            if (vm.isSac && vm.$root.user.nom) {
              var agentPreleveur = 'Agent pr\xE9leveur : ' + vm.$root.user.nom;
              if (enregistrement.CENT_COMMENT_APPLI_LABO) {
                if (!preleveurAjoute) {
                  if (enregistrement.CENT_COMMENT_APPLI_LABO.match(/Agent préleveur\s*:\s*[^|]*/i)) {
                    enregistrement.CENT_COMMENT_APPLI_LABO = enregistrement.CENT_COMMENT_APPLI_LABO.replace(/\|?\s*Agent préleveur\s*:\s*[^|]*(\||$)/gi, '|' + agentPreleveur);
                  } else {
                    enregistrement.CENT_COMMENT_APPLI_LABO += '|' + agentPreleveur;
                  }
                  preleveurAjoute = true;
                }
              } else {
                enregistrement.CENT_COMMENT_APPLI_LABO = '|' + agentPreleveur;
                preleveurAjoute = true;
              }
            }
            if (vm.checked1RapportEch) {
              if (i > 1) {
                vm.enregistrement.CENT_NRAP++;
                enregistrement.CENT_NRAP++;
              }
            }
            sessionStorage.setItem('enregistrement', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(enregistrement));

            var skipAnalysesPost = false;
            var forceCreate = false;

            if (isSimpleEdit && i === 1) {
              var dateRecord = vm.itemEdit.CENT_RECORD;
              var echantillonNum = vm.itemEdit.CENT_NUM;
              var clientId = vm.itemEdit.CENT_CLT;

              var savedEnregistrement = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(enregistrement));
              var savedAnalyses = sessionStorage.getItem('analyses');

              __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].deleteEchantillonSac(dateRecord, echantillonNum, clientId).done(function () {
                delete savedEnregistrement.CENT_NUM;
                delete savedEnregistrement.CENT_RECORD;
                sessionStorage.setItem('enregistrement', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(savedEnregistrement));
                sessionStorage.setItem('analyses', savedAnalyses);

                vm.postEnregistrementBddAsync('analyses', false, true).then(resolve);
              }).fail(function (xhr) {
                window.fail(xhr, true);
                vm.close = false;
                resolve();
              });
              return;
            }

            if (isEditWithAdditions) {
              if (i === 1) {
                var _dateRecord = vm.itemEdit.CENT_RECORD;
                var _echantillonNum = vm.itemEdit.CENT_NUM;
                var _clientId = vm.itemEdit.CENT_CLT;

                var _savedEnregistrement = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(enregistrement));
                var _savedAnalyses = sessionStorage.getItem('analyses');

                __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].deleteEchantillonSac(_dateRecord, _echantillonNum, _clientId).done(function () {
                  delete _savedEnregistrement.CENT_NUM;
                  delete _savedEnregistrement.CENT_RECORD;
                  sessionStorage.setItem('enregistrement', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(_savedEnregistrement));
                  sessionStorage.setItem('analyses', _savedAnalyses);

                  vm.postEnregistrementBddAsync('analyses', false, true).then(resolve);
                }).fail(function (xhr) {
                  window.fail(xhr, true);
                  vm.close = false;
                  resolve();
                });
                return;
              } else {
                var newEnregistrement = JSON.parse(sessionStorage.getItem('enregistrement'));
                delete newEnregistrement.CENT_NUM;
                delete newEnregistrement.CENT_RECORD;
                sessionStorage.setItem('enregistrement', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(newEnregistrement));
                forceCreate = true;
              }
            }

            if (i === nbrEchanTotal && vm.checkedEchantillonMoyen) {
              vm.postEnregistrementBddAsync('analysesMoyen', skipAnalysesPost, forceCreate).then(resolve);
            } else {
              vm.postEnregistrementBddAsync('analyses', skipAnalysesPost, forceCreate).then(resolve);
            }
          });
        });
      });

      promise.then(function () {
        if (vm.close) {
          if (vm.isSac && vm.selectedClient) {
            sessionStorage.setItem('lastCustomer', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.selectedClient));
          }
          window.vm.$bvToast.toast('L\'enregistrement a \xE9t\xE9 effectu\xE9', {
            title: 'Succ\xE8s',
            variant: 'success',
            solid: true
          });
          vm.closeForm();
        }
      });
    },
    findFamily: function findFamily(FAM) {
      var family = {};
      this.families.forEach(function (fam) {
        if (fam.CFAM_FAM === FAM) family = fam;
      });
      return family;
    },
    findTypeAnalyse: function findTypeAnalyse(typ) {
      var type = {};
      this.typesAnalyses.forEach(function (tp) {
        if (tp.value === typ) type = tp;
      });
      return type;
    },
    closeForm: function closeForm() {
      var vm = this;

      vm.close = true;
      if (vm.nbRequestRecord === 0) {
        global.model1.hide();
      }
    },
    clearForm: function clearForm() {
      this.enregistrement = {
        CENT_DATPRLT: __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD'),
        CENT_DATSOUHAIT: this.isSac ? __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD') : __WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1, 'days').format('YYYY-MM-DD'),
        CENT_CECH: null,
        CENT_COD_CLT: null,
        CENT_DATDLC: null,
        CENT_DATFAB: null,
        CENT_FAM: null,
        CENT_LIB: null,
        CENT_NBJ: null,
        CENT_NRAP: null,
        CENT_PRD: null,
        CENT_TXT1: null,
        CENT_TXT2: null,
        CENT_TXT3: null,
        CENT_TXT4: null,
        CENT_TYP: null,
        CPRD_CPRD: null,
        CENT_CLT: null
      };
      sessionStorage.removeItem('analysesMoyen');
      sessionStorage.removeItem('analyses');
      this.nbEchantillonSimilaires = 1;
      this.checkedEchantillonMoyen = false;
      this.checked1RapportEch = false;
      this.analysePreSelected = '';
      this.clientSelected = null;
      this.productDataSelected = '';
      this.familyDataPreSelected = null;
      this.productPreSelected = {};
      this.typeAnalysePreSelected = { value: 1, lib: 'jour' };
      this.middleEchantillon = false;
      this.$refs.stepWizard.reset();
    },
    preSelectAnalyse: function preSelectAnalyse() {
      var _this3 = this;

      this.analysesSelected = [];
      this.analysesList.forEach(function (analyse) {
        if (_this3.productPreSelected.ID_ANALYSES != null) {
          _this3.productPreSelected.ID_ANALYSES.forEach(function (idAnalyse) {
            if (analyse.ANA_NUM === idAnalyse) {
              _this3.analysesSelected.push(analyse);
            }
          });
        }
      });
    },
    preSelectCurrentAnalyse: function preSelectCurrentAnalyse() {
      this.analysesSelected = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.analysesList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var analyse = _step.value;

          if (this.productPreSelected.ID_ANALYSES != null) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.productPreSelected.ID_ANALYSES), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var idAnalyse = _step2.value;

                if (analyse.ANA_NUM === idAnalyse) {
                  this.analysesSelected.push(analyse);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    getSacData: function getSacData() {
      var vm = this;
      vm.families = [];
      vm.familiesForEchantillon = [];
      vm.libelleEchantillon = [];
      vm.familyDataPreSelected = [];
      vm.analysePreSelected = '';
      vm.seriesAnalyses = [];
      vm.productsForEchantillon = [];
      vm.productDataSelected = '';
      vm.products = [];

      if (vm.$root.user.login === 907 || vm.$root.user.login === 9999) {
        var userlogin = vm.$root.user.login;
        console.log(vm.clientSelected);
        vm.enregistrement['CENT_CLT'] = vm.clientSelected;
        __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getFamilyByClient(userlogin).done(function (data) {
          var pData = data.family;
          pData.forEach(function (element) {
            var dObject = {
              fullName: element.CFAM_LIB,
              CFAM_FAM: element.CFAM_FAM,
              CFAM_LIB: element.CFAM_LIB
            };
            vm.families.push(dObject);
            vm.familiesForEchantillon = vm.families;
            vm.familiesForEchantillon.sort(function (a, b) {
              return a.CFAM_LIB - b.CFAM_LIB;
            });
          });
        }).fail(function (xhr) {
          window.fail(xhr, true);
        });
        __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getProductsGenerikByClient(userlogin).done(function (data) {
          var pData = data.productsGenerik;
          pData.forEach(function (element) {
            var dObject = {
              CWL_FAM: element.CWL_FAM,
              CWL_PDT: element.CWL_PDT,
              fullName: element.CWL_NUM + ' ' + element.CWL_LIB.trim(),
              CWL_NUM: element.CWL_NUM,
              CWL_LIB: element.CWL_LIB.trim(),
              ID_ANALYSES: element.ID_ANALYSES,
              nbrEchantillon: ''
            };
            vm.libelleEchantillon.push(dObject);
          });
        }).fail(function (xhr) {
          window.fail(xhr, true);
        });
        __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getProductsByClient(userlogin).done(function (data) {
          var pData = data.products;
          pData.forEach(function (element) {
            var dObject = {
              fullName: element.CPRD_LIB,
              CPRD_PRD: element.CPRD_PRD,
              CPRD_LIB: element.CPRD_LIB,
              CPRD_CPRD: element.CPRD_CPRD
            };
            vm.products.push(dObject);
            vm.productsForEchantillon = vm.products;
            vm.productsForEchantillon.sort(function (a, b) {
              return a.CPRD_PRD - b.CPRD_PRD;
            });
          });
        }).fail(function (xhr) {
          window.fail(xhr, true);
        });
      }
    },

    buildItemEdit: function buildItemEdit() {
      var _this4 = this;

      var vm = this;
      this._isInitializingEdit = true;

      vm.enregistrement = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, vm.itemEdit);

      if (vm.isSac) {
        vm.enregistrement.CENT_DATSOUHAIT = __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD');
      }

      vm.clientSelected = vm.enregistrement.CENT_CLT;
      vm.changeClient = true;
      vm.echantillonNum = vm.enregistrement.CENT_NUM;
      vm.numRapportSelected = vm.enregistrement.CENT_NRAP;

      vm.analysePreSelected = vm.enregistrement.CENT_LIB;
      vm.typeAnalysePreSelected = vm.typesAnalyses.filter(function (itm) {
        return vm.enregistrement.CENT_TYP === itm.value;
      })[0];

      var producttoslelect = vm.productsForEchantillon.filter(function (itm) {
        return itm.CPRD_PRD === vm.enregistrement.CENT_PRD.PRD_NUM;
      })[0];
      if (producttoslelect) {
        vm.productDataSelected = producttoslelect;
      }
      var famtoslelect = vm.familiesForEchantillon.filter(function (itm) {
        return itm.CFAM_FAM === vm.enregistrement.CENT_FAM.CFAM_FAM;
      })[0];
      if (famtoslelect) {
        vm.familyDataPreSelected = famtoslelect;
        vm.enregistrement.CENT_FAM = famtoslelect.CFAM_FAM;
      }

      if (vm.isSac && vm.familyDataPreSelected && vm.familyDataPreSelected.CFAM_FAM) {
        vm.getSacSeriesAnalyses(vm.$root.user.login, vm.familyDataPreSelected.CFAM_FAM);
      }
      vm.analysesList.forEach(function (analyse) {
        if (vm.enregistrement.ANALYSES != null) {
          vm.enregistrement.ANALYSES.forEach(function (idAnalyse) {
            if (analyse.ANA_NUM === idAnalyse) {
              vm.analysesSelected.push(analyse);
            }
          });
        }
      });

      sessionStorage.setItem('analyses', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(vm.analysesSelected));
      if (this.isSac && vm.familyDataPreSelected && vm.familyDataPreSelected.CFAM_FAM) {
        var promises = [];
        if (this.$refs.commentaireLabo) {
          var laboPromise = this.$refs.commentaireLabo.fetchFields(vm.familyDataPreSelected.CFAM_FAM);
          promises.push(laboPromise);
        }
        if (this.$refs.commentaireClient) {
          var clientPromise = this.$refs.commentaireClient.fetchFields(vm.familyDataPreSelected.CFAM_FAM);
          promises.push(clientPromise);
        }

        __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
          vm.parseAndFillCommentFields();
        }).catch(function (error) {
          console.error('Erreur lors du chargement des champs dynamiques:', error);
        });
      }
      this.$nextTick(function () {
        _this4._isInitializingEdit = false;
      });
    },
    descCom: function descCom(text) {
      var nbCarateresMax = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 75;

      var nbCarateres = 0;
      if (text) {
        nbCarateres = text.length;
      }

      return nbCarateres + ' / ' + nbCarateresMax + ' caract\xE9res maximum';
    },
    parseAndFillCommentFields: function parseAndFillCommentFields() {
      var vm = this;

      if (vm.enregistrement.CENT_COMMENT_APPLI && vm.$refs.commentaireClient) {
        vm.parseCommentString(vm.enregistrement.CENT_COMMENT_APPLI, vm.$refs.commentaireClient);
      }

      if (vm.enregistrement.CENT_COMMENT_APPLI_LABO && vm.$refs.commentaireLabo) {
        var commentLabo = vm.enregistrement.CENT_COMMENT_APPLI_LABO;

        commentLabo = commentLabo.replace(/\s*\|?\s*Agent préleveur\s*:\s*[^|]*(\||$)/gi, '');

        commentLabo = commentLabo.replace(/\|\s*\|/g, '|').replace(/^\|/, '').replace(/\|$/, '');
        if (commentLabo.trim()) {
          vm.parseCommentString(commentLabo, vm.$refs.commentaireLabo);
        }
      }

      if (vm.enregistrement.CENT_FORFAIT && vm.$refs.commentaireLabo) {
        vm.$refs.commentaireLabo.setFieldValue('Forfait', vm.enregistrement.CENT_FORFAIT);
      }
    },
    parseCommentString: function parseCommentString(commentString, componentRef) {
      if (!commentString || !componentRef) return;

      var parts = commentString.split('|');
      parts.forEach(function (part) {
        var trimmedPart = part.trim();
        if (!trimmedPart) return;

        var match = trimmedPart.match(/^(.+?)\s*:\s*(.+)$/);
        if (match) {
          var key = match[1].trim();
          var value = match[2].trim();

          if (componentRef.setFieldValue && typeof componentRef.setFieldValue === 'function') {
            componentRef.setFieldValue(key, value);
          }
        }
      });
    },
    prepareCommentFieldsForSubmission: function prepareCommentFieldsForSubmission(payload) {
      if (!payload || (typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(payload)) !== 'object') {
        return payload;
      }

      if (payload.CENT_COMMENT_APPLI_LABO) {
        payload.CENT_COMMENT_APPLI_LABO = this.formatCommentWithFrenchDates(payload.CENT_COMMENT_APPLI_LABO);
      }

      if (payload.CENT_COMMENT_APPLI) {
        payload.CENT_COMMENT_APPLI = this.formatCommentWithFrenchDates(payload.CENT_COMMENT_APPLI);
      }

      return payload;
    },
    formatCommentWithFrenchDates: function formatCommentWithFrenchDates(commentString) {
      var _this5 = this;

      if (!commentString || typeof commentString !== 'string') {
        return commentString;
      }

      var parts = commentString.split('|');
      var formattedParts = parts.map(function (part) {
        return part.trim();
      }).filter(Boolean).map(function (part) {
        var match = part.match(/^(.+?:)\s*(.+)$/);
        if (!match) {
          return _this5.formatIsoDateValue(part);
        }
        var label = match[1];
        var value = match[2];
        var formattedValue = _this5.formatIsoDateValue(value);
        return (label + ' ' + formattedValue).trim();
      });

      return formattedParts.length > 0 ? '|' + formattedParts.join(' |') + ' ' : null;
    },
    formatIsoDateValue: function formatIsoDateValue(value) {
      if (!value || typeof value !== 'string') {
        return value;
      }

      var trimmedValue = value.trim();

      var isoDateTimeMatch = trimmedValue.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?(?:Z)?$/);
      if (isoDateTimeMatch) {
        var _isoDateTimeMatch = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(isoDateTimeMatch, 6),
            year = _isoDateTimeMatch[1],
            month = _isoDateTimeMatch[2],
            day = _isoDateTimeMatch[3],
            _isoDateTimeMatch$ = _isoDateTimeMatch[4],
            hours = _isoDateTimeMatch$ === undefined ? '00' : _isoDateTimeMatch$,
            _isoDateTimeMatch$2 = _isoDateTimeMatch[5],
            minutes = _isoDateTimeMatch$2 === undefined ? '00' : _isoDateTimeMatch$2;

        var formattedDate = day + '/' + month + '/' + year;
        var timePart = hours + ':' + minutes;
        return isoDateTimeMatch[4] ? formattedDate + ' ' + timePart : formattedDate;
      }

      return trimmedValue;
    }
  },
  computed: {
    syncedFamilyData: {
      get: function get() {
        return this.familyDataPreSelected;
      },
      set: function set(value) {
        this.familyDataPreSelected = value;
      }
    },
    echantillonMoyennDisplay: function echantillonMoyennDisplay() {
      if (this.$root.user.roles.ECHMOY === 1) {
        return true;
      }

      return false;
    },
    echantillonMoyennDisabled: function echantillonMoyennDisabled() {
      if (this.nbEchantillonSimilaires > 1) {
        return false;
      }

      this.checkedEchantillonMoyen = false;
      this.checked1RapportEch = false;
      return true;
    }
  },
  watch: {
    numRapportSelected: function numRapportSelected(data) {
      this.enregistrement.CENT_NRAP = this.numRapportSelected;
    },
    clientSelected: function clientSelected(val) {
      if (!this.isSac) return;
      var vm = this;
      if (!val) {
        vm.listNumRapport = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getNummRapportClientByClient(val).done(function (data) {
        vm.listNumRapport = data.data || [];

        if (vm.modeEdition !== 'edit') {
          setTimeout(function () {
            var max = 0;
            if (vm.listNumRapport && vm.listNumRapport.length) max = Math.max.apply(Math, [0].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(vm.listNumRapport)));
            vm.numRapportSelected = max + 1;
          }, 0);
        }
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    familyDataPreSelected: function familyDataPreSelected(data) {
      var _this6 = this;

      if (this._isInitializingEdit) return;
      this.enregistrement.CENT_FAM = '';
      if (data) {
        this.enregistrement.CENT_FAM = data.CFAM_FAM;
        if (this.isSac && data.CFAM_FAM) {
          var userlogin = this.$root.user.login;

          this.seriesAnalyses = [];
          this.getSacSeriesAnalyses(userlogin, data.CFAM_FAM);
          __WEBPACK_IMPORTED_MODULE_8__api_js__["a" /* default */].getProductsGenerikByClientAndFam(userlogin, data.CFAM_FAM).done(function (result) {
            _this6.libelleEchantillon = [];
            _this6.analysePreSelected = '';
            var pData = result.productsGenerik;
            pData.forEach(function (element) {
              var dObject = {
                CWL_FAM: element.CWL_FAM,
                CWL_PDT: element.CWL_PDT,
                fullName: element.CWL_NUM + ' ' + element.CWL_LIB.trim(),
                CWL_NUM: element.CWL_NUM,
                CWL_LIB: element.CWL_LIB.trim(),
                ID_ANALYSES: element.ID_ANALYSES,
                nbrEchantillon: ''
              };
              _this6.libelleEchantillon.push(dObject);
            });
          }).fail(function (xhr) {
            window.fail(xhr, true);
          });
        }
        if (this.$refs.commentaireLabo) {
          this.$refs.commentaireLabo.fetchFields(data.CFAM_FAM);
        }
        if (this.$refs.commentaireClient) {
          this.$refs.commentaireClient.fetchFields(data.CFAM_FAM);
        }
      }
    },
    productDataSelected: function productDataSelected(data) {
      this.enregistrement.CENT_PRD = '';
      if (data) {
        this.enregistrement.CENT_PRD = data.CPRD_PRD;
        this.enregistrement.CPRD_CPRD = data.CPRD_CPRD;
      }
    },
    analysePreSelected: function analysePreSelected(element) {
      this.autoCompleteForm();
    },
    productPreSelected: function productPreSelected(params) {
      this.preSelectAnalyse();
    },
    typeAnalysePreSelected: function typeAnalysePreSelected(params) {
      this.checksChamp = this.checksChamp.filter(function (champ) {
        return ['CENT_DATDLC', 'CENT_NBJ'].includes(champ) === false;
      });

      this.validator['CENT_NBJ'] = null;
      this.validator['CENT_DATDLC'] = null;
      this.validator['CENT_DATFAB'] = null;
      if (this.typeAnalysePreSelected.value === 2) {
        this.checksChamp.push('CENT_DATDLC');
      } else if (this.typeAnalysePreSelected.value === 3) {
        this.checksChamp.push('CENT_NBJ');
      } else {
        this.enregistrement.CENT_NBJ = 0;
      }
      this.enregistrement.CENT_TYP = this.typeAnalysePreSelected.value;
    },
    nbRequestRecord: function nbRequestRecord() {
      var vm = this;

      if (vm.close) {
        vm.closeForm();
      }

      if (vm.nbRequestRecord > 0) {
        vm.loading = true;
      } else {
        vm.loading = false;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(50)))

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectedAnalysesTableComponent_vue__ = __webpack_require__(607);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelectedAnalysesComponent',
  props: {
    value: {
      type: Array
    },
    items: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      analysesPreSelected: [],
      analysesPreUnSelected: [],
      localItems: []
    };
  },

  mounted: function mounted() {
    var vm = this;

    vm.buildLocalItems();
  },
  methods: {
    buildLocalItems: function buildLocalItems() {
      var vm = this;

      var iDif = 0;
      for (var i = 0; i < vm.items.length; i++) {
        var copyItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, vm.items[i]);
        var indexLocalItems = i - iDif;

        if (!vm.localItems[indexLocalItems]) {
          vm.localItems.push(copyItem);
        } else if (vm.localItems[indexLocalItems].SER_NUM !== copyItem.SER_NUM) {
          vm.localItems.splice(indexLocalItems, 0, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, copyItem));
        }

        var analysesArray = copyItem.analyses;
        if (!analysesArray && copyItem.ID_ANALYSES) {
          analysesArray = copyItem.ID_ANALYSES.map(function (id) {
            return { ANA_NUM: id };
          });
        }

        vm.localItems[indexLocalItems].analyses = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(analysesArray)).filter(function (ana) {
          return vm.value.findIndex(function (v) {
            return v.ANA_NUM === ana.ANA_NUM;
          }) === -1;
        });

        if (vm.localItems[indexLocalItems].analyses.length < 1) {
          vm.localItems.splice(indexLocalItems, 1);
          iDif++;
        }
      }
    },
    addAnalysesSelected: function addAnalysesSelected() {
      var vm = this;

      var analysesSelected = vm.value;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(vm.analysesPreSelected), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var analyse = _step.value;

          analysesSelected.push(analyse);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      vm.initFilter();

      vm.$emit('input', analysesSelected);
    },
    delAnalysesSelected: function delAnalysesSelected() {
      var vm = this;

      var analysesSelected = vm.value;

      var _loop = function _loop(analyse) {
        analysesSelected.splice(analysesSelected.findIndex(function (item) {
          return item.ANA_NUM === analyse.ANA_NUM;
        }), 1);
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(vm.analysesPreUnSelected), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var analyse = _step2.value;

          _loop(analyse);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      vm.initFilter();

      vm.$emit('input', analysesSelected);
    },
    initFilter: function initFilter() {
      var vm = this;

      vm.$refs.choiceAnalyses.initFilter();
      vm.$refs.selectedAnalyses.initFilter();
    }
  },
  watch: {
    value: function value() {
      var vm = this;

      vm.buildLocalItems();
    },
    items: function items() {
      var vm = this;

      vm.buildLocalItems();
    }
  },
  components: {
    SelectedAnalysesTableComponent: __WEBPACK_IMPORTED_MODULE_3__SelectedAnalysesTableComponent_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);





function buildNameRefTable(item) {
  return 'tableItems-' + item.SER_NUM;
}

function getIndexItem(items, item) {
  return items.findIndex(function (i) {
    return i === item;
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'selectedAnalysesTableComponent',
  props: {
    value: {
      type: Array
    },

    items: {
      type: Array,
      required: true
    },
    hasItemDetail: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localItems: [],
      localHasItemDetail: false,
      checkedItems: false,
      indeterminateItems: false,
      localFilter: '',
      localFields: [],
      localFieldsDetails: [{
        key: 'ANA_NUM',
        label: 'Ref'
      }, {
        key: 'ANA_LIB',
        label: 'Analyses à réаliser'
      }]
    };
  },

  mounted: function mounted() {
    var vm = this;

    vm.buildLocalFields();
    vm.buildLocalItems();
    vm.buildLocalHasItemDetail();
  },
  methods: {
    buildLocalFields: function buildLocalFields() {
      var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;

      vm.localFields = vm.localFieldsDetails;

      if (vm.hasItemDetail && detail === false) {
        vm.localFields = [{
          key: 'SER_LIB',
          label: 'S\xE9rie d\'analyses'
        }];
      }
    },
    buildLocalHasItemDetail: function buildLocalHasItemDetail() {
      var vm = this;

      vm.localHasItemDetail = vm.hasItemDetail;
    },
    buildLocalItems: function buildLocalItems() {
      var vm = this;

      vm.localItems = vm.items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, {
          analyses: item.analyses ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(item.analyses)) : [],
          _checked: false,
          _indeterminate: false,
          _showDetails: false
        });
      });
    },
    selectedItems: function selectedItems(items) {
      var vm = this;
      var selected = items;

      if (vm.localHasItemDetail === true) {
        selected = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(vm.localItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var refName = buildNameRefTable(item);
            var selectedItem = [];
            item._indeterminate = false;

            if (vm.$refs[refName]) {
              var displayedAnalyses = item._filteredAnalyses || item.analyses;

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(item.analyses), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var ana = _step2.value;

                  ana._checked = false;
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              for (var i = 0; i < displayedAnalyses.length; i++) {
                var analyse = displayedAnalyses[i];
                if (vm.$refs[refName].isRowSelected(i)) {
                  analyse._checked = true;
                  selected.push(analyse);
                  selectedItem.push(analyse);
                }
              }

              var allSelected = item.analyses.length > 0 && item.analyses.every(function (a) {
                return a._checked;
              });
              if (allSelected) {
                vm.selectedItem(item);
              } else if (selectedItem.length > 0) {
                var indexItem = getIndexItem(vm.localItems, item);
                vm.$refs.tableItems.unselectRow(indexItem);
                item._indeterminate = true;
                item._checked = false;
              } else {
                vm.unSelectedItemClear(item);
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        vm.indeterminateItems = false;
        if (selected.length === vm.$refs.tableItems.computedItems.length) {
          vm.checkedItems = true;
        } else if (selected.length > 0) {
          vm.indeterminateItems = true;
        } else {
          vm.checkedItems = false;
        }
      }

      vm.$emit('input', selected);
    },
    toggleItem: function toggleItem(item) {
      var vm = this;

      if (vm.localHasItemDetail === false) {
        return;
      }

      if (item._checked) {
        vm.unSelectedItemClear(item);

        if (vm.localHasItemDetail === true) {
          setTimeout(function () {
            item._showDetails = false;
          }, 0);
        }
      } else {
        if (vm.localHasItemDetail === true) {
          item._showDetails = true;
        }

        setTimeout(function () {
          vm.selectedItem(item);
        }, 0);
      }
    },
    toggleCheckbox: function toggleCheckbox(item) {
      var vm = this;

      if (!item._checked) {
        vm.unSelectedItemClear(item);
      } else {
        item._showDetails = true;

        setTimeout(function () {
          vm.selectedItem(item);
        }, 0);
      }
    },
    selectedItem: function selectedItem(item) {
      var vm = this;

      var indexItem = getIndexItem(vm.$refs.tableItems.computedItems, item);

      if (indexItem > -1) {
        if (!vm.$refs.tableItems.isRowSelected(indexItem)) {
          vm.$refs.tableItems.selectRow(indexItem);
        }
      }

      item._checked = true;

      var refName = buildNameRefTable(item);
      if (vm.$refs[refName]) {
        if (item._filteredAnalyses) {
          for (var i = 0; i < item._filteredAnalyses.length; i++) {
            vm.$refs[refName].selectRow(i);
          }
        } else {
          vm.$refs[refName].selectAllRows();
        }
      }
    },
    unSelectedItemClear: function unSelectedItemClear(item) {
      var vm = this;

      var indexItem = getIndexItem(vm.$refs.tableItems.computedItems, item);

      setTimeout(function () {
        vm.$refs.tableItems.unselectRow(indexItem);
      }, 0);

      item._checked = false;

      var refName = buildNameRefTable(item);
      if (vm.$refs[refName]) {
        vm.$refs[refName].clearSelected();
      }
    },
    filterItems: function filterItems() {
      var vm = this;

      if (vm.localFilter.trim() === '') {
        vm.localItems.forEach(function (item) {
          delete item._filteredAnalyses;
        });
        return vm.localItems;
      }

      var filter = vm.localFilter.toLowerCase();
      var norm = function norm(v) {
        return String(v == null ? '' : v).toLowerCase();
      };

      if (vm.localHasItemDetail) {
        var result = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(vm.localItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var item = _step3.value;

            delete item._filteredAnalyses;

            var filteredAnalyses = item.analyses.filter(function (analysis) {
              return norm(analysis.ANA_LIB).includes(filter) || norm(analysis.ANA_NUM).includes(filter);
            });
            var serieLibMatches = norm(item.SER_LIB).includes(filter);
            var serieNumMatches = norm(item.SER_NUM).includes(filter);
            var serieMatches = serieLibMatches || serieNumMatches;

            if (serieMatches || filteredAnalyses.length > 0) {
              if (!serieMatches && filteredAnalyses.length > 0) {
                item._filteredAnalyses = filteredAnalyses;
              } else if (serieMatches) {
                delete item._filteredAnalyses;
              }
              item._showDetails = true;
              result.push(item);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return result;
      }

      return vm.localItems.filter(function (item) {
        return norm(item.ANA_LIB).includes(filter) || norm(item.ANA_NUM).includes(filter);
      });
    },
    clearFilterItems: function clearFilterItems() {
      var vm = this;

      vm.localFilter = '';
    },
    initFilter: function initFilter() {
      var vm = this;

      vm.localFilter = '';
    }
  },
  watch: {
    items: function items() {
      var vm = this;

      if (vm.items.length === 0) {
        vm.checkedItems = false;
      }

      vm.buildLocalItems();
    },
    checkedItems: function checkedItems() {
      var vm = this;

      if (vm.checkedItems === true) {
        vm.$refs.tableItems.selectAllRows();
      } else {
        vm.$refs.tableItems.clearSelected();
      }
    },
    localFilter: function localFilter() {
      var vm = this;

      if (vm.localFilter === '') {
        vm.clearFilterItems();
      }
    }
  }
});

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConfirmationEchantillonComponent',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isSac: false,
      localFields: ['libelle', 'analyses']
    };
  },

  mounted: function mounted() {
    this.isSac = this.$root.user.login === 907 || this.$root.user.login === 9999;
  },
  methods: {
    updateCommentaireLabo: function updateCommentaireLabo() {
      var _this = this;

      if (this.commentaireLabo !== '' && this.commentaireLabo !== undefined) {
        this.items.forEach(function (item) {
          item.commentaire = _this.commentaireLabo;
        });
      }
    }
  },
  watch: {}
});

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_js__ = __webpack_require__(61);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommentaireLabo',
  props: {
    origineCom: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isSac: false,
      family: false,
      dynamicFields: [],
      fieldValues: {} };
  },

  methods: {
    fetchFields: function fetchFields(centFam) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3__api_js__["a" /* default */].getLabcoCommentByFamily(centFam).then(function (response) {
        var labcoComment = response.labcoComment || [];

        console.log('Origine:', _this.origineCom);
        var filteredFields = labcoComment.filter(function (field) {
          return field.FAMCOML_ORIGINE === _this.origineCom;
        });
        _this.dynamicFields = filteredFields;

        _this.dynamicFields.forEach(function (field) {
          _this.$set(_this.fieldValues, field.FAMCOML_STR, '');
        });
        console.log('Champs dynamiques chargés:', _this.dynamicFields.length);
        return _this.dynamicFields;
      }).catch(function (error) {
        console.error('Error fetching fields:', error);
        throw error;
      });
    },
    getListeOptions: function getListeOptions(listeValeurs) {
      return listeValeurs ? listeValeurs.split(';').map(function (val) {
        return { value: val, text: val };
      }) : [];
    },
    logFieldValues: function logFieldValues() {
      console.log('fieldValues:', this.fieldValues);
    },
    saveDynamicFieldsToSession: function saveDynamicFieldsToSession() {
      var enregistrement = {};
      try {
        enregistrement = JSON.parse(sessionStorage.getItem('enregistrement')) || {};
      } catch (e) {
        enregistrement = {};
      }

      if ('Forfait' in this.fieldValues) {
        var forfaitValue = this.fieldValues['Forfait'];

        var match = String(forfaitValue).match(/^(\d+)/);
        enregistrement.CENT_FORFAIT = match ? parseInt(match[1], 10) : null;
      }

      var commentairesArr = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.fieldValues).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return key !== 'Forfait' && value !== '' && value !== null && value !== undefined;
      }).map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        return key + ': ' + value;
      });

      var commentaires = commentairesArr.length > 0 ? '|' + commentairesArr.join(' |') + ' ' : null;

      if (this.origineCom === 'LABO') {
        enregistrement.CENT_COMMENT_APPLI_LABO = commentaires;
      } else if (this.origineCom === 'CLIENT') {
        enregistrement.CENT_COMMENT_APPLI = commentaires;
      }
      sessionStorage.setItem('enregistrement', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(enregistrement));
    },
    getDatePart: function getDatePart(key) {
      var value = this.fieldValues[key];
      if (!value) return '';
      var stringValue = String(value).trim();

      if (stringValue.includes('T')) {
        var _stringValue$split = stringValue.split('T'),
            _stringValue$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_stringValue$split, 1),
            date = _stringValue$split2[0];

        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
      }

      if (/^\d{4}-\d{2}-\d{2}$/.test(stringValue)) return stringValue;

      var ddmmyyyy = stringValue.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
      if (ddmmyyyy) {
        var _ddmmyyyy = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(ddmmyyyy, 4),
            day = _ddmmyyyy[1],
            month = _ddmmyyyy[2],
            year = _ddmmyyyy[3];

        return year + '-' + month + '-' + day;
      }

      return '';
    },
    getTimePart: function getTimePart(key) {
      var value = this.fieldValues[key];
      if (!value) return '';
      var stringValue = String(value).trim();

      if (stringValue.includes('T')) {
        var _stringValue$split3 = stringValue.split('T'),
            _stringValue$split4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_stringValue$split3, 2),
            _stringValue$split4$ = _stringValue$split4[1],
            time = _stringValue$split4$ === undefined ? '' : _stringValue$split4$;

        var timePart = time.slice(0, 5);
        if (/^\d{2}:\d{2}$/.test(timePart)) return timePart;
      }

      if (/^\d{2}:\d{2}/.test(stringValue)) {
        return stringValue.slice(0, 5);
      }

      return '';
    },
    updateDateTime: function updateDateTime(key, newValue, part) {
      var eventValue = newValue && newValue.target ? newValue.target.value : String(newValue || '');
      var inputValue = eventValue.trim();
      var currentValue = this.fieldValues[key] ? String(this.fieldValues[key]).trim() : '';

      var currentDate = '';
      var currentTime = '';

      if (currentValue.includes('T')) {
        var _currentValue$split = currentValue.split('T'),
            _currentValue$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_currentValue$split, 2),
            _currentValue$split2$ = _currentValue$split2[0],
            storedDate = _currentValue$split2$ === undefined ? '' : _currentValue$split2$,
            _currentValue$split2$2 = _currentValue$split2[1],
            storedTime = _currentValue$split2$2 === undefined ? '' : _currentValue$split2$2;

        currentDate = storedDate;
        currentTime = storedTime.slice(0, 5);
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(currentValue)) {
        currentDate = currentValue;
      } else if (/^\d{2}:\d{2}/.test(currentValue)) {
        currentTime = currentValue.slice(0, 5);
      } else {
        var ddmmyyyyMatch = currentValue.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/);
        if (ddmmyyyyMatch) {
          var _ddmmyyyyMatch = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(ddmmyyyyMatch, 6),
              day = _ddmmyyyyMatch[1],
              month = _ddmmyyyyMatch[2],
              year = _ddmmyyyyMatch[3],
              hours = _ddmmyyyyMatch[4],
              minutes = _ddmmyyyyMatch[5];

          currentDate = year + '-' + month + '-' + day;
          currentTime = hours + ':' + minutes;
        }
      }

      if (part === 'date') {
        currentDate = inputValue;
      } else if (part === 'time') {
        currentTime = inputValue.slice(0, 5);
      }

      var combinedValue = currentDate && currentTime ? currentDate + 'T' + currentTime : currentDate || currentTime;

      this.$set(this.fieldValues, key, combinedValue);
      this.saveDynamicFieldsToSession();
    },
    setFieldValue: function setFieldValue(key, value) {
      if (!key || value === undefined || value === null) return;

      var field = this.dynamicFields.find(function (f) {
        return f.FAMCOML_STR === key;
      });

      if (!field && this.dynamicFields.some(function (f) {
        return f.FAMCOML_LIBELLE;
      })) {
        field = this.dynamicFields.find(function (f) {
          return f.FAMCOML_LIBELLE === key;
        });
      }

      if (!field) {
        field = this.dynamicFields.find(function (f) {
          return f.FAMCOML_STR && f.FAMCOML_STR.toLowerCase() === key.toLowerCase() || f.FAMCOML_LIBELLE && f.FAMCOML_LIBELLE.toLowerCase() === key.toLowerCase();
        });
      }

      if (!field) {
        var keyLower = key.toLowerCase();
        field = this.dynamicFields.find(function (f) {
          var strLower = (f.FAMCOML_STR || '').toLowerCase();
          var libelleLower = (f.FAMCOML_LIBELLE || '').toLowerCase();

          if (keyLower.includes('température') && (strLower.includes('temp') || libelleLower.includes('temp'))) return true;
          if (keyLower.includes('conditionnement') && (strLower.includes('condition') || libelleLower.includes('condition'))) return true;
          if (keyLower.includes('etat') && keyLower.includes('physique') && (strLower.includes('etat') || libelleLower.includes('etat'))) return true;
          if (keyLower.includes('prélèvement') && (strLower.includes('prele') || libelleLower.includes('prele'))) return true;
          if (keyLower === 'commentaire' && (strLower.includes('comment') || libelleLower.includes('comment'))) return true;
          return false;
        });
      }

      if (!field && key === 'Commentaire' && this.origineCom === 'LABO') {
        this.$set(this.fieldValues, 'Commentaire', String(value));
        this.saveDynamicFieldsToSession();
        console.log('Champ sp\xE9cial rempli: ' + key + ' = ' + value);
        return;
      }

      if (!field && key === 'Forfait') {
        field = this.dynamicFields.find(function (f) {
          return f.FAMCOML_STR === 'Forfait';
        });
        if (field && field.FAMCOML_LISTE_VALEURS) {
          var options = field.FAMCOML_LISTE_VALEURS.split(';');
          var forfaitNumber = String(value).trim();
          var forfaitMatch = options.find(function (opt) {
            var match = opt.match(/^(\d+)/);
            return match && match[1] === forfaitNumber;
          });
          this.$set(this.fieldValues, 'Forfait', forfaitMatch || value);
          this.saveDynamicFieldsToSession();
          console.log('Champ sp\xE9cial Forfait rempli: ' + value + ' -> ' + (forfaitMatch || value));
          return;
        }
      }
      if (!field) {
        console.warn('Champ dynamique non trouv\xE9: ' + key);
        console.log('Champs dynamiques disponibles:', this.dynamicFields.map(function (f) {
          return { str: f.FAMCOML_STR, libelle: f.FAMCOML_LIBELLE };
        }));
        return;
      }
      var processedValue = value;

      switch (field.FAMCOML_TYPE) {
        case 'case à cocher':
          processedValue = ['true', 'oui', 'yes', '1', 'on', 'vrai'].includes(String(value).toLowerCase());
          break;
        case 'liste':
          if (field.FAMCOML_LISTE_VALEURS) {
            var _options = field.FAMCOML_LISTE_VALEURS.split(';');

            if (field.FAMCOML_STR === 'Forfait' && /^\d+$/.test(String(value).trim())) {
              var _forfaitNumber = String(value).trim();
              var _forfaitMatch = _options.find(function (opt) {
                var match = opt.match(/^(\d+)/);
                return match && match[1] === _forfaitNumber;
              });
              processedValue = _forfaitMatch || value;
              console.log('Forfait charg\xE9: ' + value + ' -> ' + processedValue, { options: _options, forfaitNumber: _forfaitNumber });
            } else {
              var exactMatch = _options.find(function (opt) {
                return opt === value;
              });
              var partialMatch = _options.find(function (opt) {
                return opt.toLowerCase().includes(String(value).toLowerCase()) || String(value).toLowerCase().includes(opt.toLowerCase());
              });
              processedValue = exactMatch || partialMatch || value;
            }
          }
          break;
        case 'date':
          if (value && typeof value === 'string') {
            if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
              processedValue = value;
            } else {
              var isoDateTimeMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
              if (isoDateTimeMatch) {
                var _isoDateTimeMatch = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(isoDateTimeMatch, 4),
                    day = _isoDateTimeMatch[1],
                    month = _isoDateTimeMatch[2],
                    year = _isoDateTimeMatch[3];

                processedValue = year + '-' + month + '-' + day;
              }
            }
          }
          break;
        case 'date_heure':
          if (value) {
            var stringValue = String(value).trim();

            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(stringValue)) {
              processedValue = stringValue.slice(0, 16);
            } else {
              var ddmmyyyyMatch = stringValue.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/);
              if (ddmmyyyyMatch) {
                var _ddmmyyyyMatch2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(ddmmyyyyMatch, 6),
                    _day = _ddmmyyyyMatch2[1],
                    _month = _ddmmyyyyMatch2[2],
                    _year = _ddmmyyyyMatch2[3],
                    hours = _ddmmyyyyMatch2[4],
                    minutes = _ddmmyyyyMatch2[5];

                processedValue = _year + '-' + _month + '-' + _day + 'T' + hours + ':' + minutes;
              } else {
                var ddmmyyyysMatch = stringValue.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/);
                if (ddmmyyyysMatch) {
                  var _ddmmyyyysMatch = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(ddmmyyyysMatch, 6),
                      _day2 = _ddmmyyyysMatch[1],
                      _month2 = _ddmmyyyysMatch[2],
                      _year2 = _ddmmyyyysMatch[3],
                      _hours = _ddmmyyyysMatch[4],
                      _minutes = _ddmmyyyysMatch[5];

                  processedValue = _year2 + '-' + _month2 + '-' + _day2 + 'T' + _hours + ':' + _minutes;
                } else {
                  var ddmmyyyy2Match = stringValue.match(/^(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/);
                  if (ddmmyyyy2Match) {
                    var _ddmmyyyy2Match = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(ddmmyyyy2Match, 6),
                        _day3 = _ddmmyyyy2Match[1],
                        _month3 = _ddmmyyyy2Match[2],
                        _year3 = _ddmmyyyy2Match[3],
                        _hours2 = _ddmmyyyy2Match[4],
                        _minutes2 = _ddmmyyyy2Match[5];

                    processedValue = _year3 + '-' + _month3 + '-' + _day3 + 'T' + _hours2 + ':' + _minutes2;
                  }
                }
              }
            }
          }
          break;
        default:
          processedValue = String(value);
          break;
      }

      var fieldKey = field.FAMCOML_STR;
      this.$set(this.fieldValues, fieldKey, processedValue);

      this.saveDynamicFieldsToSession();
      console.log('Champ rempli: ' + key + ' -> ' + fieldKey + ' = ' + processedValue + ' (type: ' + field.FAMCOML_TYPE + ')');
    }
  },
  computed: {
    splitFields: function splitFields() {
      var mid = Math.ceil(this.dynamicFields.length / 2);
      return [this.dynamicFields.slice(0, mid), this.dynamicFields.slice(mid)];
    }
  }
});

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderSearchComponent_vue__ = __webpack_require__(485);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ba0790_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderSearchComponent_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(623)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderSearchComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ba0790_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderSearchComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(61);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderSearch',
  components: {},
  props: ['from'],
  data: function data() {
    return {
      isSac: false,
      sacCustomers: [],
      selectedSacCustomer: null
    };
  },

  methods: {
    getSacCustomers: function getSacCustomers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getAllSacCustomers().then(function (response) {
        var customers = [];
        if (response) {
          if (Array.isArray(response.data)) {
            customers = response.data;
          } else if (Array.isArray(response.customers)) {
            customers = response.customers;
          } else if (response.data && Array.isArray(response.data.customers)) {
            customers = response.data.customers;
          }
        }

        _this.sacCustomers = customers.map(function (c) {
          return {
            value: c.CLT_NUM || c.CENT_CLT || c.CLT_NUMERO || c.CENT_NUM || null,
            label: c.CLT_RSO || c.CENT_LIB || c.name || c.CLT_NUM || c.CENT_CLT || ''
          };
        });
      }).catch(function (error) {
        console.error('Error fetching SAC customers:', error);
        _this.sacCustomers = [];
      });
    },
    onSacCustomerChange: function onSacCustomerChange(value) {
      this.$emit('sac-customer-selected', value);
    }
  },
  mounted: function mounted() {
    this.isSac = this.$root.user.login === 907 || this.$root.user.login === 9999;
    if (this.isSac) {
      this.getSacCustomers();
    }
  }
});

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderSearchComponent__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SyntheseComponent__ = __webpack_require__(628);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResultatsComponent',
  components: {
    HeaderSearch: __WEBPACK_IMPORTED_MODULE_2__HeaderSearchComponent__["a" /* default */],
    SyntheseComponent: __WEBPACK_IMPORTED_MODULE_3__components_SyntheseComponent__["a" /* default */]
  },
  data: function data() {
    return {
      msg: '',
      isBusy: true,
      results: null,
      numClient: '',
      echantillonFilter: null,
      nbreJour: 30,
      selected: 'dateDbtFin',
      tri: 'resultatsRadio',
      radioSynthese: false,
      value: null,
      jourDisabled: false,
      echantillonDisable: true,
      dateDisable: false,
      dateDebut: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(30, 'days').format('YYYY-MM-DD'),
      dateFin: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
      dateMax: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
      fields: [],
      echantillon: [],
      idEchantillon: null,
      idAnalyse: null,
      idProduct: null,
      disableRadio: false,
      disablePagination: false,
      echantillonDiplayResult: false,
      perPage: 50,
      currentPage: 1,
      totalItems: 0,
      modalTitle: '',
      modalIsBusySpinner: false,
      modalResults: null,
      modalComments: [],
      modalFieldsFor: [],
      modalBtnPrec: false,
      xhrGet: null
    };
  },

  computed: {
    dateDbt: function dateDbt() {
      if (this.dateDebut === '') {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(this.nbreJour, 'days').format('YYYY-MM-DD');
      } else {
        return this.dateDebut;
      }
    }
  },
  mounted: function mounted() {
    this.displayByResults();
  },

  methods: {
    getAllResultsByDate: function getAllResultsByDate() {
      var vm = this;
      vm.isBusy = true;

      if (vm.xhrGet) {
        vm.xhrGet.abort();
      }

      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      }

      vm.xhrGet = __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getAllResultatsByDate(vm.$root.user.login, dateDbt, dateFin, echantillonFilter, vm.currentPage, vm.perPage).done(function (data) {
        vm.results = data.resultats;
        vm.totalItems = data.total;
      }).fail(function (xhr) {
        window.fail(xhr, true);
        vm.results = [];
        vm.totalItems = 0;
      }).always(function () {
        vm.isBusy = false;
        vm.xhrGet = null;
      });
    },
    getResultsByOneEchantillon: function getResultsByOneEchantillon(idEchantillon) {
      this.modalIsBusySpinner = true;
      var vm = this;

      if (vm.xhrGet) {
        vm.xhrGet.abort();
      }

      vm.xhrGet = __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getResultsByOneEchantillon(idEchantillon).done(function (data) {
        vm.modalResults = data.resultats;
        vm.modalComments = data.commentaires;
        vm.modalTitle = data.resultats[0].LIBELLE;
        vm.modalIsBusySpinner = false;
      }).fail(function (xhr) {
        window.fail(xhr, true);
      }).always(function (xhr) {
        vm.xhrGet = null;
      });
    },
    getAllEchantillons: function getAllEchantillons() {
      var vm = this;
      vm.isBusy = true;

      if (vm.xhrGet) {
        vm.xhrGet.abort();
      }

      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;
      var productFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      }

      if (vm.productFilter !== null) {
        productFilter = vm.productFilter;
      }

      vm.xhrGet = __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getAllEchantillonsByDate(vm.$root.user.login, dateDbt, dateFin, echantillonFilter, productFilter, vm.currentPage, vm.perPage).done(function (data) {
        vm.totalItems = data.total;
        vm.results = data.echantillons;
      }).fail(function (xhr) {
        window.fail(xhr, true);
        vm.results = [];
        vm.totalItems = 0;
      }).always(function () {
        vm.isBusy = false;
        vm.xhrGet = null;
      });
    },
    getAnalyseByDate: function getAnalyseByDate() {
      var vm = this;
      vm.isBusy = true;

      if (vm.xhrGet) {
        vm.xhrGet.abort();
      }

      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      }

      vm.xhrGet = __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getAnalyseByDate(vm.$root.user.login, dateDbt, dateFin, echantillonFilter).done(function (data) {
        vm.results = data.analyses;
      }).fail(function (xhr) {
        window.fail(xhr, true);
        vm.results = [];
      }).always(function () {
        vm.isBusy = false;
        vm.xhrGet = null;
      });
    },
    getProductByDate: function getProductByDate() {
      var vm = this;
      vm.isBusy = true;

      if (vm.xhrGet) {
        vm.xhrGet.abort();
      }

      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      }

      vm.xhrGet = __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getProductByDate(vm.$root.user.login, dateDbt, dateFin, echantillonFilter).done(function (data) {
        vm.results = data.products;
      }).fail(function (xhr) {
        window.fail(xhr, true);
        vm.results = [];
      }).always(function () {
        vm.isBusy = false;
        vm.xhrGet = null;
      });
    },
    getEchantillonsByAnalyseAndDate: function getEchantillonsByAnalyseAndDate(idAnalyse) {
      this.modalIsBusySpinner = true;
      var vm = this;

      if (vm.xhrGet) {
        vm.xhrGet.abort();
      }

      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      }

      vm.xhrGet = __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getEchantillonsByAnalyseAndDate(this.$root.user.login, idAnalyse, dateDbt, dateFin, echantillonFilter).done(function (data) {
        vm.modalResults = data.echantillons;
        vm.modalTitle = data.echantillons[0].ANALYSE;
      }).fail(function (xhr) {
        window.fail(xhr, true);
      }).always(function () {
        vm.modalIsBusySpinner = false;
        vm.xhrGet = null;
      });
    },
    getEchantillonsByProductAndDate: function getEchantillonsByProductAndDate(productFilter) {
      this.modalIsBusySpinner = true;
      var vm = this;

      if (vm.xhrGet) {
        vm.xhrGet.abort();
      }

      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      }

      vm.xhrGet = __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getAllEchantillonsByDate(this.$root.user.login, dateDbt, dateFin, echantillonFilter, productFilter, 1, 999).done(function (data) {
        vm.modalResults = data.echantillons;
        vm.modalTitle = data.echantillons[0].PRODUIT;
      }).fail(function (xhr) {
        window.fail(xhr, true);
      }).always(function () {
        vm.modalIsBusySpinner = false;
        vm.xhrGet = null;
      });
    },
    rowSelected: function rowSelected(items) {
      if (this.tri === 'echantillonsRadio') {
        this.displayOneEchantillon(items.ECHANTILLON);
      }

      if (this.tri === 'analyseRadio') {
        this.displayByAnalyseByEchantillon(items.IDANALYSE);
      }

      if (this.tri === 'productRadio') {
        this.displayByProductByEchantillon(items.IDPRODUIT);
      }
    },
    displayByResults: function displayByResults() {
      var vm = this;

      vm.getAllResultsByDate();
      vm.disableRadio = false;
      vm.disablePagination = false;
      vm.radioSynthese = false;
      vm.fields = [{
        key: 'ECHANTILLON',
        label: 'N° Echantillon',
        sortable: true
      }, {
        key: 'NUM_RAPPORT',
        label: 'N° Rapport',
        sortable: true
      }, {
        key: 'LIBELLE',
        label: 'Echantillon',
        sortable: true
      }, {
        key: 'LIBELLE_ANALYSE',
        label: 'Analyse',
        sortable: true
      }, {
        key: 'DATE_COLLECTE',
        label: 'Date de collecte',
        sortable: true
      }, {
        key: 'ARRIVE',
        label: 'Date d\'arrivée',
        sortable: true
      }, {
        key: 'RESULTAT',
        label: 'Résultats',
        sortable: true,
        variant: 'info'
      }, {
        key: 'LOT',
        label: 'Lot',
        sortable: true
      }, {
        key: 'LIBELLE_ANOMALIE',
        label: 'Anomalie',
        sortable: false
      }];
    },
    displayByEchantillon: function displayByEchantillon() {
      var vm = this;

      vm.radioSynthese = false;
      vm.getAllEchantillons();
      vm.disableRadio = false;
      vm.disablePagination = false;
      vm.fields = [{
        key: 'ECHANTILLON',
        label: 'N° Echantillon',
        sortable: true
      }, {
        key: 'NUM_RAPPORT',
        label: 'N° Rapport',
        sortable: true
      }, {
        key: 'LIBELLE',
        label: 'Libelle',
        sortable: true
      }, {
        key: 'DATE_COLLECTE',
        label: 'Date de collecte',
        sortable: true
      }, {
        key: 'ARRIVE',
        label: 'Date d\'arrivée',
        sortable: true
      }, {
        key: 'RESULTAT',
        label: 'Résultats disponibles',
        sortable: true,
        variant: 'info'
      }, {
        key: 'LOT',
        label: 'Lot',
        sortable: true
      }];
    },
    displayByAnalyse: function displayByAnalyse() {
      var vm = this;

      vm.radioSynthese = false;
      vm.getAnalyseByDate();
      vm.disablePagination = true;
      vm.disableRadio = false;
      vm.fields = [{
        key: 'ANALYSE',
        label: 'Analyse',
        sortable: true
      }, {
        key: 'NB_ECH',
        label: 'Nombres d\'\xE9chantillons',
        sortable: true
      }];
    },
    displayByProduct: function displayByProduct() {
      var vm = this;

      vm.radioSynthese = false;
      vm.getProductByDate();
      vm.disablePagination = true;
      vm.disableRadio = false;
      vm.fields = [{
        key: 'PRODUIT',
        label: 'Produit',
        sortable: true
      }, {
        key: 'NB_ECH',
        label: 'Nombres d\'\xE9chantillons',
        sortable: true
      }];
    },
    displayByAnalyseByEchantillon: function displayByAnalyseByEchantillon(idAnalyse) {
      var vm = this;

      vm.idAnalyse = idAnalyse;
      vm.modalIsBusySpinner = true;
      this.modalBtnPrec = false;
      vm.$refs.modalDetail.show();

      vm.radioSynthese = false;
      vm.getEchantillonsByAnalyseAndDate(idAnalyse);
      vm.echantillonDiplayResult = false;
      vm.modalFieldsFor = [{
        key: 'ECHANTILLON',
        label: 'N° Echantillon',
        sortable: true
      }, {
        key: 'NUM_RAPPORT',
        label: 'N° Rapport',
        sortable: true
      }, {
        key: 'LIBELLE',
        label: 'Echantillon',
        sortable: true
      }, {
        key: 'RESULTAT',
        label: 'Résultats',
        sortable: true,
        variant: 'info'
      }, {
        key: 'DATE_COLLECTE',
        label: 'Date de collecte',
        sortable: true
      }, {
        key: 'ARRIVE',
        label: 'Date d\'arrivée',
        sortable: true
      }, {
        key: 'DATE_ANALYSE',
        label: 'Date d\'analyse',
        sortable: true
      }, {
        key: 'LIBELLE_ANOMALIE',
        label: 'Anomalie',
        sortable: false
      }, {
        key: 'LOT',
        label: 'Lot',
        sortable: true
      }];
    },
    displayByProductByEchantillon: function displayByProductByEchantillon(idProduct) {
      var vm = this;

      vm.idProduct = idProduct;
      vm.modalIsBusySpinner = true;
      vm.modalBtnPrec = false;
      vm.$refs.modalDetail.show();
      window.trans = vm;

      vm.radioSynthese = false;
      vm.getEchantillonsByProductAndDate(idProduct);
      vm.echantillonDiplayResult = false;
      vm.modalFieldsFor = [{
        key: 'ECHANTILLON',
        label: 'N° Echantillon',
        sortable: true
      }, {
        key: 'NUM_RAPPORT',
        label: 'N° Rapport',
        sortable: true
      }, {
        key: 'LIBELLE',
        label: 'Libelle',
        sortable: true
      }, {
        key: 'DATE_COLLECTE',
        label: 'Date de collecte',
        sortable: true
      }, {
        key: 'ARRIVE',
        label: 'Date d\'arrivée',
        sortable: true
      }, {
        key: 'RESULTAT',
        label: 'Résultats disponibles',
        sortable: true,
        variant: 'info'
      }, {
        key: 'LOT',
        label: 'Lot',
        sortable: true
      }];
    },
    displayOneEchantillon: function displayOneEchantillon(idEchantillon) {
      this.idEchantillon = idEchantillon;
      this.modalIsBusySpinner = true;

      this.modalBtnPrec = false;
      if (['productRadio', 'analyseRadio'].includes(this.tri)) {
        this.modalBtnPrec = true;
      }
      this.$refs.modalDetail.show();

      this.getResultsByOneEchantillon(idEchantillon);
      this.echantillonDiplayResult = true;
      this.modalFieldsFor = [{
        key: 'ANALYSE',
        label: 'Analyses',
        sortable: true
      }, {
        key: 'RESULTAT',
        label: 'Résulats',
        sortable: true,
        variant: 'info'
      }, {
        key: 'LIBELLE_ANOMALIE',
        label: 'Anomalie',
        sortable: false
      }, {
        key: 'COMMENTAIRES',
        label: 'Commentaires',
        sortable: true
      }];
    },
    displaySynthese: function displaySynthese() {
      var vm = this;

      vm.echantillonDiplayResult = false;
      vm.radioSynthese = true;
      vm.disablePagination = false;
      vm.disableRadio = true;
      vm.fields = [];
    },
    getResultsForRangeDates: function getResultsForRangeDates() {
      var vm = this;

      if (vm.tri === 'resultatsRadio') {
        vm.displayByResults();
      }

      if (vm.tri === 'echantillonsRadio') {
        vm.displayByEchantillon();
      }

      if (vm.tri === 'analyseRadio') {
        vm.displayByAnalyse();
      }

      if (vm.tri === 'productRadio') {
        vm.displayByProduct();
      }
    },
    modalExportData: function modalExportData() {
      if (this.tri === 'analyseRadio' && this.idEchantillon === null) {
        this.exportByAnalyse();
      } else {
        this.exportByEchantillon();
      }
    },
    modalShowOneEchantillon: function modalShowOneEchantillon(data) {
      if (this.idEchantillon === data.ECHANTILLON) {
        return;
      }

      this.displayOneEchantillon(data.ECHANTILLON);
    },
    modalPrec: function modalPrec() {
      this.idEchantillon = null;
      this.rowSelected({
        IDANALYSE: this.idAnalyse,
        IDPRODUIT: this.idProduct
      });
    },
    modalHide: function modalHide() {
      this.$refs.modalDetail.hide();
    },
    modalHidden: function modalHidden() {
      this.idEchantillon = null;
      this.idAnalyse = null;
      this.idProduct = null;
    },
    runExport: function runExport() {
      if (this.tri === 'resultatsRadio') {
        this.exportByResults();
      }

      if (this.tri === 'echantillonsRadio') {
        this.exportByEchantillon();
      }
    },
    exportByResults: function exportByResults() {
      var _this = this;

      var vm = this;
      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      }

      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getAllResultatsByDate(this.$root.user.login, dateDbt, dateFin, echantillonFilter, 1, 99999, 'csv').done(function (data) {
        _this.downloadFile(data, 'resultats');
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    exportByEchantillon: function exportByEchantillon() {
      var _this2 = this;

      var vm = this;

      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      } else if (this.idEchantillon) {
        echantillonFilter = this.idEchantillon;
      }

      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getAllEchantillonsByDate(this.$root.user.login, dateDbt, dateFin, echantillonFilter, vm.idProduct, 1, 99999, 'csv').done(function (data) {
        _this2.downloadFile(data, 'echantillons');
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    exportByAnalyse: function exportByAnalyse() {
      var _this3 = this;

      var vm = this;

      var dateDbt = null;
      var dateFin = null;
      var echantillonFilter = null;

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt;
        dateFin = vm.dateFin;
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter;
      }

      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getEchantillonsByAnalyseAndDate(this.$root.user.login, this.idAnalyse, dateDbt, dateFin, echantillonFilter, 'csv').done(function (data) {
        _this3.downloadFile(data, 'resultatsAnalyses');
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    downloadFile: function downloadFile(csv, fileName) {
      var blob = new Blob(['\uFEFF', csv]);
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName + '.csv');
      document.body.appendChild(link);
      link.click();
    }
  },
  watch: {
    selected: function selected() {
      if (this.selected === 'echantillon') {
        this.echantillonDisable = false;
      } else {
        this.echantillonDisable = true;
      }

      if (this.selected === 'dateDbtFin') {
        this.dateDisable = false;
      } else {
        this.dateDisable = true;
      }
    },
    currentPage: function currentPage() {
      this.getResultsForRangeDates();
    }
  }
});

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SyntheseComponent',
  data: function data() {
    return {
      dateDebut: __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(30, 'days').format('YYYY-MM-DD'),
      dateFin: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
      analyses: [],
      dateMax: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
      fields: [{
        key: 'data.libelle',
        label: 'Libellé',
        sortable: true
      }],
      fieldsSelected: [{
        key: 'anag_num',
        label: 'n°',
        sortable: true
      }, {
        key: 'libelle',
        label: 'Libellé',
        sortable: true
      }],
      analysesSelected: [],
      msgsErrorSave: [],
      msgNoSelected: ''
    };
  },

  computed: {
    dateDbt: function dateDbt() {}
  },
  mounted: function mounted() {
    this.getSyntheses();
  },

  methods: {
    getSyntheses: function getSyntheses() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getSyntheses().done(function (data) {
        _this.analyses = [];
        _this.msgsErrorSave = [];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.data).map(function (cle) {
          _this.analyses.push({
            key: cle,
            data: data.data[cle]
          });
        });
      }).fail(function (xhr) {
        window.fail(xhr, true);
      });
    },
    selectAnalyse: function selectAnalyse(item) {
      this.analysesSelected = item[0].data.analyses;
    },
    exportCSV: function exportCSV() {
      var _this2 = this;

      var error = false;
      this.dateDebut = this.dateDebut === null ? '' : this.dateDebut;
      this.dateFin = this.dateFin === null ? '' : this.dateFin;

      if (this.dateDebut === '' || this.dateFin === '') error = true;
      if (this.analysesSelected.length === 0) {
        this.msgNoSelected = 'Vous devez sélectionner une synthèse à exporter';
        error = true;
      }

      if (error) return;

      __WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].exportCSV(this.dateDebut, this.dateFin, this.analysesSelected).done(function (data) {
        _this2.downloadFile(data, 'syntheses');
      }).fail(function (xhr) {
        _this2.msgsErrorSave = xhr.responseJSON.erreurs;
      });
    },
    downloadFile: function downloadFile(csv, fileName) {
      var blob = new Blob(['\uFEFF', csv]);
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName + '.csv');
      document.body.appendChild(link);
      link.click();
    }
  }
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth_vue__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Auth_ModalUpdatePassword_vue__ = __webpack_require__(492);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  computed: {
    showMaintenanceMessage: function showMaintenanceMessage() {
      var today = new Date();
      var maintenanceDate = new Date('2025-08-07');
      return today <= maintenanceDate;
    }
  },
  methods: {
    disconnect: function disconnect() {
      var vm = this;

      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');

      vm.$root.user = null;
    }
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      var stringArray = value.split(' ');
      var complete = '';
      stringArray.forEach(function (word) {
        word = word.toString();
        complete += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + ' ';
      });
      return complete;
    }
  },
  components: {
    Auth: __WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth_vue__["a" /* default */],
    ModalUpdatePassword: __WEBPACK_IMPORTED_MODULE_1__components_Auth_ModalUpdatePassword_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormAuth_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalForgetPassword_vue__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalUpdatePassword_vue__ = __webpack_require__(492);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth',
  data: function data() {
    return {
      dataAuth: {},
      authLoad: false,
      upgradePassword: false,
      token: null
    };
  },

  mounted: function mounted() {
    var vm = this;
    var token = sessionStorage.getItem('token');
    if (token) {
      vm.parseToken(token);
    } else {
      setTimeout(function () {
        vm.$refs.formAuth.$refs.login.focus();
      }, 0);
    }
  },
  methods: {
    modalForgetPassword: function modalForgetPassword() {
      this.$refs.modalForgetPassword.show();
    },
    modalUpdatePassword: function modalUpdatePassword() {
      this.$refs.modalUpdatePassword.show();
    },
    onSubmit: function onSubmit() {
      var vm = this;

      vm.authLoad = true;
      window.$.ajax({
        method: 'POST',
        url: "https://auth.aclccp.com" + '/labco-token',
        data: {
          login: vm.dataAuth.login,
          correspondant: vm.dataAuth.correspondant,
          password: vm.dataAuth.password
        }
      }).done(function (data) {
        if (data.data && data.data.password_no_secure) {
          vm.upgradePassword = true;
          setTimeout(function () {
            vm.$refs.modalUpdatePassword.show();
          }, 0);
        } else {
          vm.password = '';
          vm.parseToken(data.jwt);
        }
      }).fail(function (xhr) {
        var errorMessage = window.fail(xhr);
        vm.$bvToast.toast(errorMessage, {
          title: 'Oups !',
          variant: 'warning',
          solid: true
        });
      }).always(function () {
        vm.authLoad = false;
      });
    },
    focusLogin: function focusLogin() {
      this.$refs.formAuth.$refs.focusThis.focus();
    },
    parseToken: function parseToken(token) {
      var vm = this;

      var dataToken = JSON.parse(atob(token.split('.')[1]));
      if (dataToken.exp * 1000 > Date.now()) {
        vm.token = token;

        sessionStorage.setItem('token', token);
        vm.$root.user = {
          login: dataToken.login,
          correspondant: dataToken.correspondant,
          right: dataToken.right,
          roles: dataToken.roles,
          rso: dataToken.rso,
          nom: dataToken.nom
        };
      }
    }
  },
  components: {
    FormAuth: __WEBPACK_IMPORTED_MODULE_0__FormAuth_vue__["a" /* default */],
    ModalForgetPassword: __WEBPACK_IMPORTED_MODULE_1__ModalForgetPassword_vue__["a" /* default */],
    ModalUpdatePassword: __WEBPACK_IMPORTED_MODULE_2__ModalUpdatePassword_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form-auth',
  data: function data() {
    return {
      showInputLocal: {}
    };
  },

  props: {
    value: {
      type: Object,
      required: true
    },
    showInput: {
      type: Object,
      required: false
    }
  },
  mounted: function mounted() {
    var vm = this;

    vm.buildShowInput();
  },
  methods: {
    buildShowInput: function buildShowInput() {
      var vm = this;

      vm.showInputLocal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        login: true,
        correspondant: true,
        password: true
      }, vm.showInput);
    }
  }
});

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormAuth_vue__ = __webpack_require__(177);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-forget-password',
  data: function data() {
    return {};
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    forgetPasswordOnSubmit: function forgetPasswordOnSubmit() {
      var vm = this;
      vm.forgetPasswordLoad = true;
      window.$.ajax({
        method: 'POST',
        url: "https://auth.aclccp.com" + '/labco/user-forget-password',
        data: {
          login: vm.value.login,
          correspondant: vm.value.correspondant
        }
      }).done(function () {
        vm.hide();
        vm.$bvToast.toast('Vous allez recevoir un mail avec la procédure créé un nouveau mot de passe', {
          title: 'Oubli de mot de passe',
          variant: 'success',
          solid: true
        });
      }).fail(function (xhr) {
        var errorMessage = window.fail(xhr);
        vm.$bvToast.toast(errorMessage, {
          title: 'Oups !',
          variant: 'warning',
          solid: true
        });
      }).always(function () {
        vm.forgetPasswordLoad = false;
      });
    },
    forgetPasswordOk: function forgetPasswordOk(bvModalEvt) {
      var vm = this;

      bvModalEvt.preventDefault();

      if (!this.$refs.forgetPasswordForm.checkValidity()) {
        return;
      }

      vm.forgetPasswordOnSubmit();
    },
    show: function show() {
      this.$refs.modalForgetPassword.show();
    },
    hide: function hide() {
      this.$refs.modalForgetPassword.hide();
    },
    initModal: function initModal() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.formAuth.$refs.login.focus();
      }, 0);
    }
  },
  computed: {
    checkFormValidity: function checkFormValidity() {
      var vm = this;
      var valid = false;

      if (vm.value.login && vm.value.login.length > 0 && vm.value.correspondant && vm.value.correspondant.length > 0) {
        valid = true;
      }

      return valid;
    }
  },
  components: {
    FormAuth: __WEBPACK_IMPORTED_MODULE_0__FormAuth_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalUpdatePassword_vue__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9452a0cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalUpdatePassword_vue__ = __webpack_require__(645);
function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalUpdatePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9452a0cc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalUpdatePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormAuth_vue__ = __webpack_require__(177);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-update-password',
  data: function data() {
    return {
      title: null,
      message: null,
      showInput: {
        login: false,
        correspondant: false,
        password: true
      },
      passwordNew: null,
      passwordNewBis: null,
      updatePasswordLoad: false
    };
  },

  props: {
    value: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    upgradePassword: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted: function mounted() {
    var vm = this;

    if (vm.$route.query.token) {
      vm.show();
    }
  },
  methods: {
    initModal: function initModal() {
      var vm = this;

      vm.title = 'Mise à jour de votre mot de passe';
      vm.message = null;

      if (vm.$route.query.token) {
        vm.value.login = vm.$route.query.login;
        vm.value.correspondant = vm.$route.query.correspondant;
        vm.value.password = vm.$route.query.token;

        vm.title = 'Nouveau mot de passe';
      }

      console.log('initModal', vm.upgradePassword);
      if (vm.upgradePassword) {
        vm.message = 'Pour plus de s\xE9curit\xE9, veuillez changer votre mot de passe.';
      }

      if (vm.$route.query.token || vm.upgradePassword) {
        vm.showInput.password = false;

        setTimeout(function () {
          vm.$refs.passwordNew.focus();
        }, 100);
      } else {
        setTimeout(function () {
          vm.$refs.formAuth.$refs.password.focus();
        }, 100);
      }
    },
    show: function show() {
      this.$refs.modalUpdatePassword.show();
    },
    hide: function hide() {
      var vm = this;

      vm.$refs.modalUpdatePassword.hide();
    },
    hidden: function hidden() {
      this.$router.replace('/');
    },
    handleOk: function handleOk(bvModalEvt) {
      var vm = this;

      bvModalEvt.preventDefault();
      vm.handleSubmit();
    },
    handleSubmit: function handleSubmit() {
      var vm = this;

      if (!vm.checkFormValidity) {
        return;
      }

      vm.updatePassword();
    },

    updatePassword: function updatePassword() {
      var vm = this;

      vm.updatePasswordLoad = true;
      window.$.ajax({
        method: 'PUT',
        url: "https://auth.aclccp.com" + '/labco/user-password',
        data: {
          login: vm.value.login,
          correspondant: vm.value.correspondant,
          password: vm.value.password,
          passwordNew: vm.passwordNew
        }
      }).done(function () {
        var message = 'Votre mot de passe \xE0 \xE9t\xE9 mis \xE0 jour';
        if (vm.$route.query.token || vm.upgradePassword) {
          message = 'Vous pouvez maintenant vous connectez avec votre nouveau mot de passe';
        }
        vm.upgradePassword = false;
        vm.value.password = vm.passwordNew;
        vm.hide();
        vm.$bvToast.toast(message, {
          title: 'Mise à jour de votre mot de passe',
          variant: 'success',
          solid: true
        });
      }).fail(function (xhr) {
        var errorMessage = window.fail(xhr);
        vm.$bvToast.toast(errorMessage, {
          title: 'Oups !',
          variant: 'warning',
          solid: true
        });
      }).always(function () {
        vm.updatePasswordLoad = false;
      });
    }
  },
  computed: {
    checkFormValidity: function checkFormValidity() {
      var vm = this;
      var valid = false;

      if (vm.passwordNewValide && vm.passwordNewBisValide) {
        valid = true;
      }

      return valid;
    },

    passwordNewValide: function passwordNewValide() {
      var vm = this;
      var state = null;

      if (!vm.passwordNew || vm.passwordNew.length < 1) {
        return state;
      }

      if (vm.checkConstrainteLen && vm.checkConstrainteNumber && vm.checkConstrainteMajuscule && vm.checkConstrainteMinuscule && vm.checkConstrainteSpecialChar) {
        state = true;
      } else {
        state = false;
      }

      return state;
    },
    passwordNewBisValide: function passwordNewBisValide() {
      var vm = this;
      var state = null;

      if (vm.passwordNew && vm.passwordNewBis && vm.passwordNewValide) {
        if (vm.passwordNew === vm.passwordNewBis) {
          state = true;
        } else {
          state = false;
        }
      }

      return state;
    },
    checkConstrainteLen: function checkConstrainteLen() {
      var vm = this;
      var state = null;

      if (vm.passwordNew) {
        if (vm.passwordNew.length >= 8) {
          state = true;
        } else {
          state = false;
        }
      }

      return state;
    },
    checkConstrainteNumber: function checkConstrainteNumber() {
      var vm = this;
      var state = null;

      if (vm.passwordNew) {
        if (/[0-9]/.exec(vm.passwordNew) === null) {
          state = false;
        } else {
          state = true;
        }
      }

      return state;
    },
    checkConstrainteMajuscule: function checkConstrainteMajuscule() {
      var vm = this;
      var state = null;

      if (vm.passwordNew) {
        if (/[A-Z]/.exec(vm.passwordNew) === null) {
          state = false;
        } else {
          state = true;
        }
      }

      return state;
    },
    checkConstrainteMinuscule: function checkConstrainteMinuscule() {
      var vm = this;
      var state = null;

      if (vm.passwordNew) {
        if (/[a-z]/.exec(vm.passwordNew) === null) {
          state = false;
        } else {
          state = true;
        }
      }

      return state;
    },
    checkConstrainteSpecialChar: function checkConstrainteSpecialChar() {
      var vm = this;
      var state = null;

      if (vm.passwordNew) {
        if (/[\W]/.exec(vm.passwordNew) === null) {
          state = false;
        } else {
          state = true;
        }
      }

      return state;
    }
  },
  components: {
    FormAuth: __WEBPACK_IMPORTED_MODULE_0__FormAuth_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);













global.$ = global.jQuery = __WEBPACK_IMPORTED_MODULE_7_jquery___default.a;

global.fail = function (xhr) {
  var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (xhr.statusText === 'abort') {
    return;
  }

  var error = 'Une erreur s\'est produite';
  if (xhr.responseJSON) {
    if (xhr.responseJSON.erreurs && typeof xhr.responseJSON.erreurs === 'string') {
      error = xhr.responseJSON.erreurs;
    } else if (xhr.responseJSON.erreurs && xhr.responseJSON.erreurs.length) {
      error = xhr.responseJSON.erreurs.map(function (error) {
        return error.message;
      }).join('<br>');
    } else if (xhr.responseJSON.exception) {
      error = xhr.responseJSON.exception.map(function (error) {
        return error.message;
      }).join('<br>');
    } else if (xhr.responseJSON.message) {
      error = xhr.responseJSON.message;
    }
  }

  if (display) {
    window.vm.$bvToast.toast(error, {
      title: 'Oups, il y a un probl\xE8me',
      variant: 'warning',
      solid: true
    });
  }

  return error;
};

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.productionTip = false;

window.vm = new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  data: {
    user: null
  },
  components: {
    App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(50)))

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AccueilComponent__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NewEnregistrementComponent__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DetailEchantillonComponent__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ResultatsComponent__ = __webpack_require__(626);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [{
    path: '/',
    name: 'accueil',
    component: __WEBPACK_IMPORTED_MODULE_2__components_AccueilComponent__["a" /* default */]
  }, {
    path: '/Resultats',
    name: 'resultats',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ResultatsComponent__["a" /* default */]
  }, {
    path: '/Demande/Nouvelle',
    name: 'nouvelleDemande',
    component: __WEBPACK_IMPORTED_MODULE_3__components_NewEnregistrementComponent__["a" /* default */]
  }, {
    path: '/Demande/Echantillon/Detail',
    name: 'detailEchantillon',
    component: __WEBPACK_IMPORTED_MODULE_4__components_DetailEchantillonComponent__["a" /* default */]
  }, {
    path: '/Demande/Change',
    name: 'changeDemande'
  }, {
    path: '/Demande/Recherche',
    name: 'rechercheDemande'
  }, {
    path: '/Contact',
    name: 'contact'
  }, {
    path: '/Utilisateur',
    name: 'comptaeUt'
  }]
}));

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccueilComponent_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02473aa5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccueilComponent_vue__ = __webpack_require__(543);
function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccueilComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02473aa5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccueilComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 542:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"accueil"},[_c('div',{staticClass:"contains w-25"},[_c('b-button',{staticClass:"backresultats button_accueil_style mb-4",attrs:{"to":"/Resultats","block":""}},[_vm._v("Vos résultats")]),_vm._v(" "),(_vm.$root.user.roles.ENREG === 1)?_c('b-button',{staticClass:"backanalyse button_accueil_style mb-4",attrs:{"to":"/Demande/Nouvelle","block":""}},[_vm._v("Demandes d'analyses")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEnregistrementComponent_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bffa082_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEnregistrementComponent_vue__ = __webpack_require__(625);
function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEnregistrementComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bffa082_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewEnregistrementComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 326,
	"./af.js": 326,
	"./ar": 327,
	"./ar-dz": 328,
	"./ar-dz.js": 328,
	"./ar-kw": 329,
	"./ar-kw.js": 329,
	"./ar-ly": 330,
	"./ar-ly.js": 330,
	"./ar-ma": 331,
	"./ar-ma.js": 331,
	"./ar-sa": 332,
	"./ar-sa.js": 332,
	"./ar-tn": 333,
	"./ar-tn.js": 333,
	"./ar.js": 327,
	"./az": 334,
	"./az.js": 334,
	"./be": 335,
	"./be.js": 335,
	"./bg": 336,
	"./bg.js": 336,
	"./bm": 337,
	"./bm.js": 337,
	"./bn": 338,
	"./bn-bd": 339,
	"./bn-bd.js": 339,
	"./bn.js": 338,
	"./bo": 340,
	"./bo.js": 340,
	"./br": 341,
	"./br.js": 341,
	"./bs": 342,
	"./bs.js": 342,
	"./ca": 343,
	"./ca.js": 343,
	"./cs": 344,
	"./cs.js": 344,
	"./cv": 345,
	"./cv.js": 345,
	"./cy": 346,
	"./cy.js": 346,
	"./da": 347,
	"./da.js": 347,
	"./de": 348,
	"./de-at": 349,
	"./de-at.js": 349,
	"./de-ch": 350,
	"./de-ch.js": 350,
	"./de.js": 348,
	"./dv": 351,
	"./dv.js": 351,
	"./el": 352,
	"./el.js": 352,
	"./en-au": 353,
	"./en-au.js": 353,
	"./en-ca": 354,
	"./en-ca.js": 354,
	"./en-gb": 355,
	"./en-gb.js": 355,
	"./en-ie": 356,
	"./en-ie.js": 356,
	"./en-il": 357,
	"./en-il.js": 357,
	"./en-in": 358,
	"./en-in.js": 358,
	"./en-nz": 359,
	"./en-nz.js": 359,
	"./en-sg": 360,
	"./en-sg.js": 360,
	"./eo": 361,
	"./eo.js": 361,
	"./es": 362,
	"./es-do": 363,
	"./es-do.js": 363,
	"./es-mx": 364,
	"./es-mx.js": 364,
	"./es-us": 365,
	"./es-us.js": 365,
	"./es.js": 362,
	"./et": 366,
	"./et.js": 366,
	"./eu": 367,
	"./eu.js": 367,
	"./fa": 368,
	"./fa.js": 368,
	"./fi": 369,
	"./fi.js": 369,
	"./fil": 370,
	"./fil.js": 370,
	"./fo": 371,
	"./fo.js": 371,
	"./fr": 372,
	"./fr-ca": 373,
	"./fr-ca.js": 373,
	"./fr-ch": 374,
	"./fr-ch.js": 374,
	"./fr.js": 372,
	"./fy": 375,
	"./fy.js": 375,
	"./ga": 376,
	"./ga.js": 376,
	"./gd": 377,
	"./gd.js": 377,
	"./gl": 378,
	"./gl.js": 378,
	"./gom-deva": 379,
	"./gom-deva.js": 379,
	"./gom-latn": 380,
	"./gom-latn.js": 380,
	"./gu": 381,
	"./gu.js": 381,
	"./he": 382,
	"./he.js": 382,
	"./hi": 383,
	"./hi.js": 383,
	"./hr": 384,
	"./hr.js": 384,
	"./hu": 385,
	"./hu.js": 385,
	"./hy-am": 386,
	"./hy-am.js": 386,
	"./id": 387,
	"./id.js": 387,
	"./is": 388,
	"./is.js": 388,
	"./it": 389,
	"./it-ch": 390,
	"./it-ch.js": 390,
	"./it.js": 389,
	"./ja": 391,
	"./ja.js": 391,
	"./jv": 392,
	"./jv.js": 392,
	"./ka": 393,
	"./ka.js": 393,
	"./kk": 394,
	"./kk.js": 394,
	"./km": 395,
	"./km.js": 395,
	"./kn": 396,
	"./kn.js": 396,
	"./ko": 397,
	"./ko.js": 397,
	"./ku": 398,
	"./ku.js": 398,
	"./ky": 399,
	"./ky.js": 399,
	"./lb": 400,
	"./lb.js": 400,
	"./lo": 401,
	"./lo.js": 401,
	"./lt": 402,
	"./lt.js": 402,
	"./lv": 403,
	"./lv.js": 403,
	"./me": 404,
	"./me.js": 404,
	"./mi": 405,
	"./mi.js": 405,
	"./mk": 406,
	"./mk.js": 406,
	"./ml": 407,
	"./ml.js": 407,
	"./mn": 408,
	"./mn.js": 408,
	"./mr": 409,
	"./mr.js": 409,
	"./ms": 410,
	"./ms-my": 411,
	"./ms-my.js": 411,
	"./ms.js": 410,
	"./mt": 412,
	"./mt.js": 412,
	"./my": 413,
	"./my.js": 413,
	"./nb": 414,
	"./nb.js": 414,
	"./ne": 415,
	"./ne.js": 415,
	"./nl": 416,
	"./nl-be": 417,
	"./nl-be.js": 417,
	"./nl.js": 416,
	"./nn": 418,
	"./nn.js": 418,
	"./oc-lnc": 419,
	"./oc-lnc.js": 419,
	"./pa-in": 420,
	"./pa-in.js": 420,
	"./pl": 421,
	"./pl.js": 421,
	"./pt": 422,
	"./pt-br": 423,
	"./pt-br.js": 423,
	"./pt.js": 422,
	"./ro": 424,
	"./ro.js": 424,
	"./ru": 425,
	"./ru.js": 425,
	"./sd": 426,
	"./sd.js": 426,
	"./se": 427,
	"./se.js": 427,
	"./si": 428,
	"./si.js": 428,
	"./sk": 429,
	"./sk.js": 429,
	"./sl": 430,
	"./sl.js": 430,
	"./sq": 431,
	"./sq.js": 431,
	"./sr": 432,
	"./sr-cyrl": 433,
	"./sr-cyrl.js": 433,
	"./sr.js": 432,
	"./ss": 434,
	"./ss.js": 434,
	"./sv": 435,
	"./sv.js": 435,
	"./sw": 436,
	"./sw.js": 436,
	"./ta": 437,
	"./ta.js": 437,
	"./te": 438,
	"./te.js": 438,
	"./tet": 439,
	"./tet.js": 439,
	"./tg": 440,
	"./tg.js": 440,
	"./th": 441,
	"./th.js": 441,
	"./tk": 442,
	"./tk.js": 442,
	"./tl-ph": 443,
	"./tl-ph.js": 443,
	"./tlh": 444,
	"./tlh.js": 444,
	"./tr": 445,
	"./tr.js": 445,
	"./tzl": 446,
	"./tzl.js": 446,
	"./tzm": 447,
	"./tzm-latn": 448,
	"./tzm-latn.js": 448,
	"./tzm.js": 447,
	"./ug-cn": 449,
	"./ug-cn.js": 449,
	"./uk": 450,
	"./uk.js": 450,
	"./ur": 451,
	"./ur.js": 451,
	"./uz": 452,
	"./uz-latn": 453,
	"./uz-latn.js": 453,
	"./uz.js": 452,
	"./vi": 454,
	"./vi.js": 454,
	"./x-pseudo": 455,
	"./x-pseudo.js": 455,
	"./yo": 456,
	"./yo.js": 456,
	"./zh-cn": 457,
	"./zh-cn.js": 457,
	"./zh-hk": 458,
	"./zh-hk.js": 458,
	"./zh-mo": 459,
	"./zh-mo.js": 459,
	"./zh-tw": 460,
	"./zh-tw.js": 460
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 547;

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectedAnalysesComponent_vue__ = __webpack_require__(480);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd8f07b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectedAnalysesComponent_vue__ = __webpack_require__(611);
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectedAnalysesComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd8f07b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectedAnalysesComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectedAnalysesTableComponent_vue__ = __webpack_require__(481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a257520_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectedAnalysesTableComponent_vue__ = __webpack_require__(610);
function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a257520"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectedAnalysesTableComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a257520_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectedAnalysesTableComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 608:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var http = function http(params) {
    params.url = "https://api.labco-s.com" + params.path;
    params.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params.data);
    params.contentType = 'application/json';
    params.headers = {
      Authorization: 'Bearer ' + sessionStorage.getItem('token')
    };
    if (params.blob) {
      params.xhrFields = {
        responseType: 'blob'
      };
    }
    var request = window.$.ajax(params);

    request.fail(function (xhr) {
      if (xhr.status === 401) {
        window.vm.$bvToast.toast('Oups, vous n\'\xEAtes pas identifi\xE9', {
          title: 'Identification requise',
          variant: 'warning',
          solid: true
        });
        setTimeout(function () {
          window.vm.$children[0].disconnect();
        }, 3000);
      }
      if (xhr.status === 403) {
        window.vm.$bvToast.toast('Oups, vos droits sont insuffisants', {
          title: 'Droit insuffisants',
          variant: 'warning',
          solid: true
        });
      }
    });
    return request;
  };
  var api = {
    getAllResultatsByDate: function getAllResultatsByDate(numClient) {
      var dateDebut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var dateFin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var echantillonNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      var limite = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 50;
      var format = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

      return http({
        path: '/allResultatsByDate?numClient=' + numClient + '&page=' + page + '&limite=' + limite + (echantillonNum != null ? '&echantillonNum=' + echantillonNum : '') + (dateDebut != null ? '&dateDebut=' + dateDebut : '') + (dateFin != null ? '&dateFin=' + dateFin : '') + (format != null ? '&format=' + format : '')
      });
    },
    getResultsByOneEchantillon: function getResultsByOneEchantillon(echantillonNum) {
      return http({
        path: '/resultsByOneEchantillon?echantillonNum=' + echantillonNum
      });
    },
    getAllEchantillonsByDate: function getAllEchantillonsByDate(numClient) {
      var dateDebut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var dateFin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var echantillonNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var idProduct = arguments[4];
      var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
      var limite = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 50;
      var format = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

      return http({
        path: '/allEchantillonsByDate?numClient=' + numClient + '&page=' + page + '&limite=' + limite + (echantillonNum != null ? '&echantillonNum=' + echantillonNum : '') + (idProduct != null ? '&idProduct=' + idProduct : '') + (dateDebut != null ? '&dateDebut=' + dateDebut : '') + (dateFin != null ? '&dateFin=' + dateFin : '') + (format != null ? '&format=' + format : '')
      });
    },
    getEchantillonsByAnalyseAndDate: function getEchantillonsByAnalyseAndDate(numClient, idAnalyse) {
      var dateDebut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var dateFin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var echantillonNum = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var format = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

      return http({
        path: '/resultsByAnalyse?numClient=' + numClient + '&idAnalyse=' + idAnalyse + (echantillonNum != null ? '&echantillonNum=' + echantillonNum : '') + (dateDebut != null ? '&dateDebut=' + dateDebut : '') + (dateFin != null ? '&dateFin=' + dateFin : '') + (format != null ? '&format=' + format : '')
      });
    },
    getEchantillonsByProductAndDate: function getEchantillonsByProductAndDate(numClient, idProduit) {
      var dateDebut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var dateFin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var echantillonNum = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var format = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

      return http({
        path: '/resultsByAnalyse?numClient=' + numClient + '&idProduit=' + idProduit + (echantillonNum != null ? '&echantillonNum=' + echantillonNum : '') + (dateDebut != null ? '&dateDebut=' + dateDebut : '') + (dateFin != null ? '&dateFin=' + dateFin : '') + (format != null ? '&format=' + format : '')
      });
    },
    getAnalyseByDate: function getAnalyseByDate(numClient) {
      var dateDebut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var dateFin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var echantillonNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return http({
        path: '/analysesByDate?numClient=' + numClient + (echantillonNum != null ? '&echantillonNum=' + echantillonNum : '') + (dateDebut != null ? '&dateDebut=' + dateDebut : '') + (dateFin != null ? '&dateFin=' + dateFin : '')
      });
    },
    getProductByDate: function getProductByDate(numClient) {
      var dateDebut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var dateFin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var echantillonNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      return http({
        path: '/productsByDate?numClient=' + numClient + (echantillonNum != null ? '&echantillonNum=' + echantillonNum : '') + (dateDebut != null ? '&dateDebut=' + dateDebut : '') + (dateFin != null ? '&dateFin=' + dateFin : '')
      });
    },
    getProductsByClient: function getProductsByClient(idClient) {
      return http({
        path: '/getProductsByClient?idClient=' + idClient
      });
    },
    getSeriesAnalyses: function getSeriesAnalyses() {
      return http({
        path: '/series-analyses'
      });
    },
    getSeriesAnalysesSac: function getSeriesAnalysesSac(idClient, idFamily) {
      return http({
        path: '/series-analysesSac?idClient=' + idClient + '&idFamily=' + idFamily
      });
    },
    getAllSacCustomers: function getAllSacCustomers() {
      return http({
        path: '/getAllSacCustomers'
      });
    },
    getProductsGenerikByClient: function getProductsGenerikByClient(idClient) {
      return http({
        path: '/getProductsGenerikByClient?idClient=' + idClient
      });
    },
    getProductsGenerikByClientAndFam: function getProductsGenerikByClientAndFam(idClient, idFamily) {
      return http({
        path: '/getProductsGenerikByClientAndFam?idClient=' + idClient + '&idFamily=' + idFamily
      });
    },
    getFamilyByClient: function getFamilyByClient(idClient) {
      return http({
        path: '/getFamilyByClient?idClient=' + idClient
      });
    },
    getLabcoCommentByFamily: function getLabcoCommentByFamily(idFamily) {
      return http({
        path: '/getLabcoCommentByFamily?idFamily=' + idFamily
      });
    },
    getRefClient: function getRefClient() {
      return http({
        path: '/ref-client'
      });
    },
    getRefFournisseur: function getRefFournisseur() {
      return http({
        path: '/ref-fournisseur'
      });
    },
    postEnregistrement: function postEnregistrement(data) {
      return http({
        path: '/enregistrementProduit',
        type: 'post',
        data: { data: data },
        async: false
      });
    },
    putEnregistrement: function putEnregistrement(data) {
      return http({
        path: '/enregistrementProduit/' + data.CENT_RECORD + '/' + data.CENT_NUM,
        type: 'put',
        data: data
      });
    },
    postAnalyse: function postAnalyse(data) {
      return http({
        path: '/enregistrementAnalyse',
        type: 'post',
        data: data
      });
    },
    getAnalysesByClient: function getAnalysesByClient() {
      return http({
        path: '/getAnalysesByClient'
      });
    },
    getNummRapportClient: function getNummRapportClient() {
      return http({
        path: '/getNumRapportsClientDay'
      });
    },
    getNummRapportClientByClient: function getNummRapportClientByClient(idClient) {
      return http({
        path: '/getNumRapportsClientDay?idClient=' + idClient
      });
    },
    getAnalyses: function getAnalyses() {
      return http({
        path: '/enregistrementAnalyse'
      });
    },
    getSyntheses: function getSyntheses() {
      return http({
        path: '/synthese-analyses'
      });
    },
    exportCSV: function exportCSV(dateDebut, dateFin, anagNums) {
      var nums = '';
      anagNums.forEach(function (anag) {
        nums += '&anag_nums[]=' + anag.anag_num;
      });
      return http({
        path: '/export?&dateDebut=' + dateDebut + '&dateFin=' + dateFin + nums
      });
    },
    getEnregistrementByClient: function getEnregistrementByClient(idClient, dateDebut, dateFin) {
      var select = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      var limite = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 50;
      var format = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

      return http({
        path: '/getEnregistrementsByClient?idClient=' + idClient + '&dateDebut=' + dateDebut + '&dateFin=' + dateFin + '&select=' + select + '&page=' + page + '&limite=' + limite + (format != null ? '&format=' + format : '')
      });
    },
    deleteEchantillon: function deleteEchantillon(dateRecord, echantillonNum) {
      return http({
        path: '/enregistrementProduit/' + dateRecord + '/' + echantillonNum,
        type: 'delete'
      });
    },
    deleteEchantillonSac: function deleteEchantillonSac(dateRecord, echantillonNum, idClient) {
      return http({
        path: '/enregistrementProduit/' + dateRecord + '/' + echantillonNum + '/' + idClient,
        type: 'delete'
      });
    }
  };
  return api;
})());

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{staticClass:"mb-1"},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Recherche"},model:{value:(_vm.localFilter),callback:function ($$v) {_vm.localFilter=$$v},expression:"localFilter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{attrs:{"disabled":!_vm.localFilter},on:{"click":_vm.clearFilterItems}},[_c('i',{staticClass:"fas fa-times"})])],1)],1)],1),_vm._v(" "),_c('b-table',{ref:"tableItems",attrs:{"sticky-header":"","responsive":"","striped":"","hover":"","bordered":"","items":_vm.filterItems(),"fields":_vm.localFields,"selectable":"","select-mode":"multi","selectedVariant":"success"},on:{"row-clicked":_vm.toggleItem,"row-selected":_vm.selectedItems},scopedSlots:_vm._u([{key:"head(ANA_LIB)",fn:function(data){return [_vm._v("\n      "+_vm._s(data.label)+"\n      "),_c('b-form-checkbox',{staticClass:"float-right",attrs:{"indeterminate":_vm.indeterminateItems},model:{value:(_vm.checkedItems),callback:function ($$v) {_vm.checkedItems=$$v},expression:"checkedItems"}})]}},{key:"cell(SER_LIB)",fn:function(row){return [_vm._v("\n      "+_vm._s(row.item.SER_LIB)+"\n      "),_c('div',{staticClass:"float-right"},[_c('b-form-checkbox',{attrs:{"indeterminate":row.item._indeterminate,"size":"lg"},on:{"change":function($event){return _vm.toggleCheckbox(row.item)}},model:{value:(row.item._checked),callback:function ($$v) {_vm.$set(row.item, "_checked", $$v)},expression:"row.item._checked"}})],1)]}},{key:"row-details",fn:function(row){return [_c('b-table',{ref:("tableItems-" + (row.item.SER_NUM)),attrs:{"striped":"","hover":"","bordered":"","items":row.item._filteredAnalyses ? row.item._filteredAnalyses : row.item.analyses,"fields":_vm.localFieldsDetails,"thead-class":"d-none","selectable":"","select-mode":"multi","selectedVariant":"success"},on:{"row-selected":_vm.selectedItems}})]}}])},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle color_green_labco",attrs:{"type":"grow"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('SelectedAnalysesTableComponent',{ref:"choiceAnalyses",attrs:{"items":_vm.localItems,"hasItemDetail":true},model:{value:(_vm.analysesPreSelected),callback:function ($$v) {_vm.analysesPreSelected=$$v},expression:"analysesPreSelected"}})],1),_vm._v(" "),_c('b-col',{staticClass:"d-flex justify-content-center",attrs:{"cols":"1"}},[_c('div',{staticClass:"mt-5"},[_c('div',{staticClass:"m-3"},[_c('b-button',{on:{"click":_vm.addAnalysesSelected}},[_c('i',{staticClass:"fa fa-angle-right"})])],1),_vm._v(" "),_c('div',{staticClass:"m-3"},[_c('b-button',{on:{"click":_vm.delAnalysesSelected}},[_c('i',{staticClass:"fa fa-angle-left"})])],1)])]),_vm._v(" "),_c('b-col',[_c('SelectedAnalysesTableComponent',{ref:"selectedAnalyses",attrs:{"items":_vm.value,"hasItemDetail":false},model:{value:(_vm.analysesPreUnSelected),callback:function ($$v) {_vm.analysesPreUnSelected=$$v},expression:"analysesPreUnSelected"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("\n      Les prestations réalisées sous accréditation\n      ("),_c('a',{attrs:{"href":"https://tools.cofrac.fr/annexes/sect1/1-6933.pdf","target":"_blank"}},[_vm._v("Accréditation n°1-6933, portée sur www.cofrac.fr")]),_vm._v(")\n      sont identifiées par le symbole \"*\"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmationEchantillonComponent_vue__ = __webpack_require__(482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3223656a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmationEchantillonComponent_vue__ = __webpack_require__(613);
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmationEchantillonComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3223656a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmationEchantillonComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"detailTabl"},[_c('b-col',[_c('h6',{staticClass:"text-center"},[_vm._v("Détail échantillon")]),_vm._v(" "),_c('div',[_c('b-table',{staticClass:"detailConfirm",attrs:{"striped":"","items":_vm.items,"fields":_vm.localFields},scopedSlots:_vm._u([{key:"cell(libelle)",fn:function(data){return [_c('b-form-input',{attrs:{"type":"text","maxlength":"95"},model:{value:(data.item.libelle),callback:function ($$v) {_vm.$set(data.item, "libelle", $$v)},expression:"data.item.libelle"}})]}},{key:"cell(analyses)",fn:function(data){return _vm._l((data.item.analyses),function(ana,index){return _c('small',{key:index},[_vm._v("\n            "+_vm._s(ana.ANA_NUM)+" "+_vm._s(ana.ANA_LIB)),_c('br')])})}}])})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommentaireLabo_vue__ = __webpack_require__(483);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0472cdfa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommentaireLabo_vue__ = __webpack_require__(620);
function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommentaireLabo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0472cdfa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommentaireLabo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 615:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[(_vm.dynamicFields.length > 0)?_c('b-col',{attrs:{"md":"12"}},[(_vm.dynamicFields.length > 0)?_c('b-row',[_c('b-col',{attrs:{"md":"6"}},_vm._l((_vm.splitFields[0]),function(field,index){return _c('b-row',{key:index,staticClass:"mb-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" "+_vm._s(field.FAMCOML_STR)+"\n                  "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),(field.FAMCOML_TYPE === 'liste' && field.FAMCOML_LISTE_VALEURS)?_c('b-form-select',{attrs:{"id":field.FAMCOML_STR,"options":_vm.getListeOptions(field.FAMCOML_LISTE_VALEURS),"placeholder":"Sélectionner une valeur"},on:{"change":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues[field.FAMCOML_STR]),callback:function ($$v) {_vm.$set(_vm.fieldValues, field.FAMCOML_STR, $$v)},expression:"fieldValues[field.FAMCOML_STR]"}}):(field.FAMCOML_TYPE === 'date')?_c('b-form-input',{attrs:{"id":field.FAMCOML_STR,"type":"date","placeholder":"Entrer une date"},on:{"input":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues[field.FAMCOML_STR]),callback:function ($$v) {_vm.$set(_vm.fieldValues, field.FAMCOML_STR, $$v)},expression:"fieldValues[field.FAMCOML_STR]"}}):(field.FAMCOML_TYPE === 'date_heure')?_c('div',{staticClass:"d-flex flex-column flex-md-row align-items-stretch"},[_c('b-form-input',{staticClass:"mb-2 mb-md-0 mr-md-2",attrs:{"id":((field.FAMCOML_STR) + "-date"),"value":_vm.getDatePart(field.FAMCOML_STR),"type":"date","placeholder":"Entrer une date"},on:{"input":function($event){return _vm.updateDateTime(field.FAMCOML_STR, $event, 'date')}}}),_vm._v(" "),_c('b-form-input',{attrs:{"id":((field.FAMCOML_STR) + "-time"),"value":_vm.getTimePart(field.FAMCOML_STR),"type":"time","placeholder":"Entrer une heure"},on:{"input":function($event){return _vm.updateDateTime(field.FAMCOML_STR, $event, 'time')}}})],1):(field.FAMCOML_TYPE === 'case à cocher')?_c('b-form-checkbox',{attrs:{"id":field.FAMCOML_STR},on:{"change":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues[field.FAMCOML_STR]),callback:function ($$v) {_vm.$set(_vm.fieldValues, field.FAMCOML_STR, $$v)},expression:"fieldValues[field.FAMCOML_STR]"}},[_vm._v("\n                  "+_vm._s(field.FAMCOML_STR)+"\n                ")]):_c('b-form-input',{attrs:{"id":field.FAMCOML_STR,"type":"text","placeholder":("Entrer une valeur pour " + (field.FAMCOML_STR))},on:{"input":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues[field.FAMCOML_STR]),callback:function ($$v) {_vm.$set(_vm.fieldValues, field.FAMCOML_STR, $$v)},expression:"fieldValues[field.FAMCOML_STR]"}})],1)],1)],1)}),1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_vm._l((_vm.splitFields[1]),function(field,index){return _c('b-row',{key:index + _vm.splitFields[0].length,staticClass:"mb-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" "+_vm._s(field.FAMCOML_STR)+"\n                  "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),(field.FAMCOML_TYPE === 'liste' && field.FAMCOML_LISTE_VALEURS)?_c('b-form-select',{attrs:{"id":field.FAMCOML_STR,"options":_vm.getListeOptions(field.FAMCOML_LISTE_VALEURS),"placeholder":"Sélectionner une valeur"},on:{"change":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues[field.FAMCOML_STR]),callback:function ($$v) {_vm.$set(_vm.fieldValues, field.FAMCOML_STR, $$v)},expression:"fieldValues[field.FAMCOML_STR]"}}):(field.FAMCOML_TYPE === 'date')?_c('b-form-input',{attrs:{"id":field.FAMCOML_STR,"type":"date","placeholder":"Entrer une date"},on:{"input":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues[field.FAMCOML_STR]),callback:function ($$v) {_vm.$set(_vm.fieldValues, field.FAMCOML_STR, $$v)},expression:"fieldValues[field.FAMCOML_STR]"}}):(field.FAMCOML_TYPE === 'date_heure')?_c('div',{staticClass:"d-flex flex-column flex-md-row align-items-stretch"},[_c('b-form-input',{staticClass:"mb-2 mb-md-0 mr-md-2",attrs:{"id":((field.FAMCOML_STR) + "-date"),"value":_vm.getDatePart(field.FAMCOML_STR),"type":"date","placeholder":"Entrer une date"},on:{"input":function($event){return _vm.updateDateTime(field.FAMCOML_STR, $event, 'date')}}}),_vm._v(" "),_c('b-form-input',{attrs:{"id":((field.FAMCOML_STR) + "-time"),"value":_vm.getTimePart(field.FAMCOML_STR),"type":"time","placeholder":"Entrer une heure"},on:{"input":function($event){return _vm.updateDateTime(field.FAMCOML_STR, $event, 'time')}}})],1):(field.FAMCOML_TYPE === 'case à cocher')?_c('b-form-checkbox',{attrs:{"id":field.FAMCOML_STR},on:{"change":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues[field.FAMCOML_STR]),callback:function ($$v) {_vm.$set(_vm.fieldValues, field.FAMCOML_STR, $$v)},expression:"fieldValues[field.FAMCOML_STR]"}},[_vm._v("\n                  "+_vm._s(field.FAMCOML_STR)+"\n                ")]):_c('b-form-input',{attrs:{"id":field.FAMCOML_STR,"type":"text","placeholder":("Entrer une valeur pour " + (field.FAMCOML_STR))},on:{"input":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues[field.FAMCOML_STR]),callback:function ($$v) {_vm.$set(_vm.fieldValues, field.FAMCOML_STR, $$v)},expression:"fieldValues[field.FAMCOML_STR]"}})],1)],1)],1)}),_vm._v(" "),(_vm.origineCom === 'LABO')?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" Commentaire Labo\n                "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"Commentaire Labo","placeholder":"Entrer un commentaire","type":"text"},on:{"input":_vm.saveDynamicFieldsToSession},model:{value:(_vm.fieldValues['Commentaire']),callback:function ($$v) {_vm.$set(_vm.fieldValues, 'Commentaire', $$v)},expression:"fieldValues['Commentaire']"}})],1)],1):_vm._e()],2)],1):_vm._e()],1):_c('b-col',{attrs:{"md":"12"}},[_c('p',[_vm._v("Aucun champ à afficher.")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-overlay',{attrs:{"show":_vm.loading},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center"},[(_vm.nbRequestRecord)?_c('h5',[_vm._v("Enregistrement en cours")]):_c('h5',[_vm._v("Chargement en cours")]),_vm._v(" "),_c('b-spinner',{staticClass:"color_green_labco",attrs:{"type":"grow"}})],1)]},proxy:true}])},[_c('form-wizard',{ref:"stepWizard",attrs:{"start-index":0,"color":"#F7931E","title":"","subtitle":"","step-":"","back-button-text":"Retour","next-button-text":"Suivant","finish-button-text":"Enregistrer"},on:{"on-complete":_vm.confirmation,"on-change":_vm.verifAndSetAnalyse}},[_c('tab-content',{attrs:{"title":"Détails de l'échantillon","icon":"fas fa-vial","before-change":_vm.postEnregistrementStorage}},[_c('b-card',[_c('b-form',{ref:"rulesForm"},[_c('b-form-group',[_c('b-row',[_c('b-col',{staticClass:"p-0",attrs:{"md":"12","lg":"12"}},[_c('b-input-group',[_c('b-col',[(_vm.modeEdition !== 'edit')?_c('b-form-group',[_c('b-row',[(_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('b-form-group',[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" Client\n                                "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),[_c('multiselect',{class:_vm.validator['CENT_CLT'] === false ? 'input-error' : '',attrs:{"options":_vm.clients,"searchable":true,"close-on-select":true,"clear-on-select":false,"preserve-search":true,"placeholder":"Rechercher un client","track-by":"login","custom-label":_vm.customLabel},on:{"input":_vm.onClientSelected},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_vm._v("\n                                    "+_vm._s(option.fullName)+" ("+_vm._s(option.login)+")\n                                  ")]}}],null,false,993647649),model:{value:(_vm.selectedClient),callback:function ($$v) {_vm.selectedClient=$$v},expression:"selectedClient"}})]],2)],1):_vm._e(),_vm._v(" "),(_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('b-form-group',[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" Famille\n                                "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('multiselect',{class:_vm.validator['CENT_FAM'] === false ? 'input-error' : '',attrs:{"options":_vm.familiesForEchantillon,"selectLabel":"","selectedLabel":"Sélectionné","deselectLabel":"","track-by":"CFAM_FAM","label":"fullName","preserve-search":true,"disabled":!_vm.clientSelected && _vm.isSac},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(option.CFAM_LIB))])]}}],null,false,3594487330),model:{value:(_vm.syncedFamilyData),callback:function ($$v) {_vm.syncedFamilyData=$$v},expression:"syncedFamilyData"}})],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('b-form-group',{attrs:{"description":_vm.descCom(_vm.analysePreSelected, 95)}},[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" Libellé échantillon\n                          "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('div',[_c('b-form-input',{attrs:{"list":"my-list-id","state":_vm.validator['CENT_LIB'],"maxlength":"95"},model:{value:(_vm.analysePreSelected),callback:function ($$v) {_vm.analysePreSelected=$$v},expression:"analysePreSelected"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"my-list-id"}},_vm._l((_vm.libelleEchantillon),function(option){return _c('option',{key:option.CWL_NUM,domProps:{"value":option.fullName}})}),0)],1)])],1)],1)],1),_vm._v(" "),(!_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('b-form-group',[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" Produit\n                      "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('multiselect',{class:_vm.validator['CENT_PRD'] === false ? 'input-error' : '',attrs:{"options":_vm.productsForEchantillon,"selectLabel":"","selectedLabel":"Sélectionné","deselectLabel":"","track-by":"fullName","label":"fullName","preserve-search":true},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_c('strong',[_c('span'),_vm._v(" "+_vm._s(option.CPRD_LIB))])]}}],null,false,107234360),model:{value:(_vm.productDataSelected),callback:function ($$v) {_vm.productDataSelected=$$v},expression:"productDataSelected"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('b-form-group',[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" Famille\n                        "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('multiselect',{class:_vm.validator['CENT_FAM'] === false ? 'input-error' : '',attrs:{"options":_vm.familiesForEchantillon,"selectLabel":"","selectedLabel":"Sélectionné","deselectLabel":"","track-by":"CFAM_FAM","label":"fullName","preserve-search":true,"disabled":!_vm.clientSelected && _vm.isSac},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(option.CFAM_LIB))])]}}],null,false,3594487330),model:{value:(_vm.syncedFamilyData),callback:function ($$v) {_vm.syncedFamilyData=$$v},expression:"syncedFamilyData"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"12","lg":"12"}},[_c('hr')]),_vm._v(" "),(!_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"description":_vm.descCom(_vm.enregistrement.CENT_CECH, 10)}},[_c('h6',[_vm._v("Code échantillon")]),_vm._v(" "),_c('b-form-input',{attrs:{"maxlength":"10"},model:{value:(_vm.enregistrement.CENT_CECH),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_CECH", $$v)},expression:"enregistrement.CENT_CECH"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',[_c('h6',[_c('i',{staticClass:"fa fa-angle-down"}),_vm._v(" N° Rapport\n                      "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.listNumRapport},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(option))])]}}]),model:{value:(_vm.numRapportSelected),callback:function ($$v) {_vm.numRapportSelected=$$v},expression:"numRapportSelected"}})],1)],1),_vm._v(" "),(!_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"description":_vm.descCom(_vm.enregistrement.CENT_TXT1, 80)}},[_c('h6',[(_vm.itemsRefClient.length)?_c('i',{staticClass:"fa fa-angle-down"}):_vm._e(),_vm._v("\n                      Ref client\n                    ")]),_vm._v(" "),_c('div',[_c('b-form-input',{attrs:{"list":"listRefClient","disabled":!_vm.canAddClient,"maxlength":"80"},model:{value:(_vm.enregistrement.CENT_TXT1),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_TXT1", $$v)},expression:"enregistrement.CENT_TXT1"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"listRefClient"}},_vm._l((_vm.itemsRefClient),function(option){return _c('option',{key:option.ID,domProps:{"value":option.libelle}})}),0)],1)])],1):_vm._e(),_vm._v(" "),(!_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"description":_vm.descCom(_vm.enregistrement.CENT_TXT2, 80)}},[_c('h6',[(_vm.itemsRefFournisseur.length)?_c('i',{staticClass:"fa fa-angle-down"}):_vm._e(),_vm._v("\n                      Ref fournisseur\n                    ")]),_vm._v(" "),_c('div',[_c('b-form-input',{attrs:{"list":"listRefFournisseur","disabled":!_vm.canAddFournisseur,"maxlength":"80"},model:{value:(_vm.enregistrement.CENT_TXT2),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_TXT2", $$v)},expression:"enregistrement.CENT_TXT2"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"listRefFournisseur"}},_vm._l((_vm.itemsRefFournisseur),function(option){return _c('option',{key:option.ID,domProps:{"value":option.libelle}})}),0)],1)])],1):_vm._e(),_vm._v(" "),(!_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"description":_vm.descCom(_vm.enregistrement.CENT_TXT3, 80)}},[_c('h6',[_vm._v("N° de lot")]),_vm._v(" "),_c('b-form-input',{attrs:{"maxlength":"80"},model:{value:(_vm.enregistrement.CENT_TXT3),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_TXT3", $$v)},expression:"enregistrement.CENT_TXT3"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',{attrs:{"description":_vm.descCom(_vm.enregistrement.CENT_COD_CLT, 10)}},[_c('h6',[_vm._v("Votre code produit")]),_vm._v(" "),_c('b-form-input',{attrs:{"maxlength":"10"},model:{value:(_vm.enregistrement.CENT_COD_CLT),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_COD_CLT", $$v)},expression:"enregistrement.CENT_COD_CLT"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("\n                      Date prélèvement "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"inputDATPRLT",attrs:{"onfocus":"(this.type='date')","onBlur":"(this.type='text')","data-vv-as":"'Date prélèvement'","type":"text","state":_vm.validator['CENT_DATPRLT']},on:{"blur":_vm.checkStateModel},model:{value:(_vm.enregistrement.CENT_DATPRLT),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_DATPRLT", $$v)},expression:"enregistrement.CENT_DATPRLT"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("Date réception "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"inputDATSOUHAIT",attrs:{"onfocus":"(this.type='date')","onBlur":"(this.type='text')","data-vv-as":"'Date prélèvement'","type":"text","state":_vm.validator['CENT_DATSOUHAIT']},model:{value:(_vm.enregistrement.CENT_DATSOUHAIT),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_DATSOUHAIT", $$v)},expression:"enregistrement.CENT_DATSOUHAIT"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("Date fabrication")]),_vm._v(" "),(_vm.typeAnalysePreSelected.value === 3)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('b-form-input',{ref:"inputDATFAB",attrs:{"state":_vm.validator['CENT_DATFAB'],"onfocus":"(this.type='date')","onBlur":"(this.type='text')","type":"text"},model:{value:(_vm.enregistrement.CENT_DATFAB),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_DATFAB", $$v)},expression:"enregistrement.CENT_DATFAB"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("\n                      Délai de mise en analyse\n                      "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.typesAnalyses,"selectLabel":"Entrée : sélectionner","selectedLabel":"Sélectionné","deselectLabel":"Entrée : supprimer","label":"lib","track-by":"lib"},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(option.lib))])]}}]),model:{value:(_vm.typeAnalysePreSelected),callback:function ($$v) {_vm.typeAnalysePreSelected=$$v},expression:"typeAnalysePreSelected"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("\n                      J+\n                      "),(_vm.typeAnalysePreSelected.value === 3)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('b-form-input',{attrs:{"state":_vm.validator['CENT_NBJ'],"placeholder":"J +","disabled":_vm.typeAnalysePreSelected.value === 1},model:{value:(_vm.enregistrement.CENT_NBJ),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_NBJ", $$v)},expression:"enregistrement.CENT_NBJ"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("DLC")]),_vm._v(" "),(_vm.typeAnalysePreSelected.value === 2)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('b-form-input',{ref:"inputDATDLC",attrs:{"onfocus":"(this.type='date')","onBlur":"(this.type='text')","type":"text","state":_vm.validator['CENT_DATDLC']},model:{value:(_vm.enregistrement.CENT_DATDLC),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_DATDLC", $$v)},expression:"enregistrement.CENT_DATDLC"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"12"}},[_c('b-form-group',{attrs:{"description":_vm.descCom(_vm.enregistrement.CENT_TXT4, 75)}},[_c('h6',[_vm._v("Commentaires")]),_vm._v(" "),_c('b-form-input',{attrs:{"maxlength":"75"},model:{value:(_vm.enregistrement.CENT_TXT4),callback:function ($$v) {_vm.$set(_vm.enregistrement, "CENT_TXT4", $$v)},expression:"enregistrement.CENT_TXT4"}})],1)],1),_vm._v(" "),(_vm.modeEdition !== 'edit' || _vm.isSac)?_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("Nombre échantillons similaires")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"number","min":"1"},model:{value:(_vm.nbEchantillonSimilaires),callback:function ($$v) {_vm.nbEchantillonSimilaires=_vm._n($$v)},expression:"nbEchantillonSimilaires"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.echantillonMoyennDisplay && (_vm.modeEdition !== 'edit' || _vm.isSac))?_c('b-col',{attrs:{"md":"3","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("Echantillon moyen")]),_vm._v(" "),_c('div',[_c('b-form-checkbox',{attrs:{"switch":"","size":"lg","name":"check-button","disabled":_vm.echantillonMoyennDisabled},model:{value:(_vm.checkedEchantillonMoyen),callback:function ($$v) {_vm.checkedEchantillonMoyen=$$v},expression:"checkedEchantillonMoyen"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.echantillonMoyennDisplay && (_vm.modeEdition !== 'edit' || _vm.isSac))?_c('b-col',{attrs:{"md":"3","lg":"3"}},[_c('b-form-group',[_c('h6',[_vm._v("1 rapport par échantillon")]),_vm._v(" "),_c('div',[_c('b-form-checkbox',{attrs:{"switch":"","size":"lg","name":"check-button","disabled":_vm.echantillonMoyennDisabled},model:{value:(_vm.checked1RapportEch),callback:function ($$v) {_vm.checked1RapportEch=$$v},expression:"checked1RapportEch"}})],1)])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),(_vm.isSac)?_c('tab-content',{attrs:{"title":"Commentaire Labo","icon":"fas fa-comment"}},[_c('div',[_c('b-row',[_c('b-col',[_c('CommentaireLabo',{ref:"commentaireLabo",attrs:{"origineCom":"LABO"}})],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.isSac)?_c('tab-content',{attrs:{"title":"Commentaire Client","icon":"fas fa-comment"}},[_c('div',[_c('b-row',[_c('b-col',[_c('CommentaireLabo',{ref:"commentaireClient",attrs:{"origineCom":"CLIENT"}})],1)],1)],1)]):_vm._e(),_vm._v(" "),_c('tab-content',{attrs:{"title":"Analyses","icon":"fas fa-cogs","before-change":_vm.postAnalyseStorage}},[_c('div',[_c('b-row',[_c('b-col',[_c('SelectedAnalysesComponent',{attrs:{"items":_vm.seriesAnalyses},model:{value:(_vm.analysesSelected),callback:function ($$v) {_vm.analysesSelected=$$v},expression:"analysesSelected"}})],1)],1)],1)]),_vm._v(" "),(_vm.checkedEchantillonMoyen)?_c('tab-content',{attrs:{"title":"Analyses sur l échantillon moyen","icon":"fas fa-cogs","before-change":_vm.postAnalyseMoyenStorage}},[_c('div',[_c('b-row',[_c('b-col',[_c('SelectedAnalysesComponent',{attrs:{"items":_vm.seriesAnalyses},model:{value:(_vm.analysesMoyenSelected),callback:function ($$v) {_vm.analysesMoyenSelected=$$v},expression:"analysesMoyenSelected"}})],1)],1)],1)]):_vm._e(),_vm._v(" "),(!_vm.checkedEchantillonMoyen)?_c('tab-content',{attrs:{"title":"Confirmation","icon":"fas fa-check"}},[_c('ConfirmationEchantillonComponent',{attrs:{"items":_vm.recapEnregistrement}})],1):_vm._e(),_vm._v(" "),(_vm.checkedEchantillonMoyen)?_c('tab-content',{attrs:{"title":"Confirmation","icon":"fas fa-check"}},[_c('ConfirmationEchantillonComponent',{attrs:{"items":_vm.recapEnregistrement}})],1):_vm._e()],1),_vm._v(" "),_c('b-overlay',{attrs:{"show":_vm.overlayAnalysesSelected,"no-wrap":""},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center p-3",attrs:{"tabindex":"-1","role":"dialog"}},[_c('p',[_c('strong',{attrs:{"id":"form-confirm-label"}},[_vm._v("\n              Êtes-vous sûr, il n'y a aucune analyse sélectionnée !\n            ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('b-button',{staticClass:"mr-3",attrs:{"variant":"outline-success"},on:{"click":_vm.overlayAnalysesSelectedCancel}},[_vm._v("\n              J'ajoute des analyses\n            ")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":_vm.overlayAnalysesSelectedOk}},[_vm._v("Oui, je n'ai pas trouvé d'analyse")])],1)])]},proxy:true}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backPic"},[_c('b-col',{staticClass:"row ml-10 flex mt-5 inputResp"},[_c('div',[_c('h5',{staticClass:"border_bottom"},[_vm._v("Rechercher")])]),_vm._v(" "),_c('b-form-radio-group',{staticClass:"Dflex",attrs:{"size":"sm"},model:{value:(_vm.$parent.selected),callback:function ($$v) {_vm.$set(_vm.$parent, "selected", $$v)},expression:"$parent.selected"}},[_c('b-col',[(_vm.from == 'Resultats')?_c('b-input-group',{staticClass:"mb-2"},[_c('b-form-radio',{staticClass:"align-items-center",attrs:{"value":"echantillon","disabled":_vm.$parent.disableRadio}},[_c('span',{staticClass:"mt-1"},[_vm._v("Echantillon N°   ")])]),_vm._v(" "),_c('b-form-input',{attrs:{"disabled":_vm.$parent.echantillonDisable || _vm.$parent.disableRadio,"size":"sm"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$parent.getResultsForRangeDates($event)}},model:{value:(_vm.$parent.echantillonFilter),callback:function ($$v) {_vm.$set(_vm.$parent, "echantillonFilter", $$v)},expression:"$parent.echantillonFilter"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{attrs:{"disabled":!_vm.$parent.echantillonFilter,"size":"sm"},on:{"click":function($event){_vm.$parent.echantillonFilter = ''}}},[_c('i',{staticClass:"fa fa-times"})])],1)],1):_vm._e(),_vm._v(" "),(_vm.from == 'Demandes')?_c('b-input-group',{staticClass:"mb-2"},[_c('b-form-checkbox',{on:{"change":_vm.$parent.getResultsForRangeDates},model:{value:(_vm.$parent.select),callback:function ($$v) {_vm.$set(_vm.$parent, "select", $$v)},expression:"$parent.select"}},[_c('span',{staticClass:"mt-1"},[_vm._v("Lister les demandes déjà traitées")])])],1):_vm._e()],1),_vm._v(" "),_c('b-col',[_c('b-input-group',{staticClass:"mb-2"},[_c('div',{staticClass:"d-flex flex-column align-items-end"},[_c('div',{staticClass:"d-flex align-items-center mb-2"},[_c('b-form-radio',{staticClass:"align-items-center mb-2",attrs:{"aria-selected":"selected","value":"dateDbtFin","disabled":_vm.$parent.disableRadio}},[_c('div',{staticStyle:{"width":"2em"}},[_vm._v("Du  ")])]),_vm._v(" "),_c('b-form-input',{staticStyle:{"width":"12em"},attrs:{"disabled":_vm.$parent.dateDisable || _vm.$parent.disableRadio,"type":"date","size":"sm","id":"targetDates"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$parent.getResultsForRangeDates($event)}},model:{value:(_vm.$parent.dateDebut),callback:function ($$v) {_vm.$set(_vm.$parent, "dateDebut", $$v)},expression:"$parent.dateDebut"}})],1),_vm._v(" "),_c('div',[_c('b-input-group',{staticClass:"align-items-center"},[_c('div',{staticStyle:{"width":"2em"}},[_vm._v("Au  ")]),_vm._v(" "),_c('b-form-input',{staticStyle:{"width":"12em"},attrs:{"disabled":_vm.$parent.dateDisable || _vm.$parent.disableRadio,"max":_vm.$parent.dateMax,"type":"date","size":"sm"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$parent.getResultsForRangeDates($event)}},model:{value:(_vm.$parent.dateFin),callback:function ($$v) {_vm.$set(_vm.$parent, "dateFin", $$v)},expression:"$parent.dateFin"}})],1)],1)])])],1)],1),_vm._v(" "),(_vm.isSac)?_c('div',{staticClass:"mb-2",staticStyle:{"width":"18rem","margin-right":"1rem"}},[_c('b-form-select',{staticClass:"mr-2",attrs:{"options":_vm.sacCustomers,"size":"sm","disabled":!_vm.sacCustomers || _vm.sacCustomers.length === 0,"aria-label":"Sélection client SAC","text-field":'label',"value-field":'value'},on:{"change":_vm.onSacCustomerChange},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":null}},[_vm._v("-- Tous les clients --")])]},proxy:true}],null,false,2633071146),model:{value:(_vm.selectedSacCustomer),callback:function ($$v) {_vm.selectedSacCustomer=$$v},expression:"selectedSacCustomer"}})],1):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"btn btn-resultats rad btn btn-secondary btn-secondary mb-3",attrs:{"size":"sm","disabled":_vm.$parent.disableRadio},on:{"click":_vm.$parent.getResultsForRangeDates}},[_vm._v("Rechercher")])],1),_vm._v(" "),_c('b-col',[(_vm.from === 'Resultats')?_c('b-form-radio-group',{staticClass:"mb-3",attrs:{"buttons":"","size":"sm"},model:{value:(_vm.$parent.tri),callback:function ($$v) {_vm.$set(_vm.$parent, "tri", $$v)},expression:"$parent.tri"}},[_c('b-form-radio',{staticClass:"text-left btn-resultats rad mr-2",class:{
          'font-weight-bold': _vm.$parent.tri === 'resultatsRadio' ? true : false,
        },attrs:{"value":"resultatsRadio"},on:{"change":_vm.$parent.displayByResults}},[_c('span',[_vm._v("Résultats")])]),_vm._v(" "),_c('b-form-radio',{staticClass:"text-left btn-resultats rad mr-2",class:{
          'font-weight-bold':
            _vm.$parent.tri === 'echantillonsRadio' ? true : false,
        },attrs:{"value":"echantillonsRadio"},on:{"change":_vm.$parent.displayByEchantillon}},[_c('span',[_vm._v("Echantillons")])]),_vm._v(" "),_c('b-form-radio',{staticClass:"text-left btn-resultats rad mr-2",class:{
          'font-weight-bold': _vm.$parent.tri === 'analyseRadio' ? true : false,
        },attrs:{"value":"analyseRadio"},on:{"change":_vm.$parent.displayByAnalyse}},[_c('span',[_vm._v("Analyses")])]),_vm._v(" "),_c('b-form-radio',{staticClass:"text-left btn-resultats rad mr-2",class:{
          'font-weight-bold': _vm.$parent.tri === 'productRadio' ? true : false,
        },attrs:{"value":"productRadio"},on:{"change":_vm.$parent.displayByProduct}},[_c('span',[_vm._v("Produits")])]),_vm._v(" "),(_vm.$root.user.right['Labco-s']['/synthese-analyses'])?_c('b-form-radio',{staticClass:"text-left btn-resultats rad mr-2",class:{
          'font-weight-bold': _vm.$parent.tri === 'synthese' ? true : false,
        },attrs:{"value":"syntheseRadio"},on:{"change":_vm.$parent.displaySynthese}},[_c('span',[_vm._v("Synthèse")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.from === 'Demandes')?_c('b-dropdown',{staticClass:"float-right ml-3 mr-3 mb-3",attrs:{"text":"Documents","right":""}},[_c('b-dropdown-item',{attrs:{"href":"http://www.aclccp.com/doc/230115_BAC.pdf","target":"_blank"}},[_vm._v("Réaliser un prélèvement")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"http://www.aclccp.com/doc/230115_TRANS.pdf","target":"_blank"}},[_vm._v("Transport des prélèvements")])],1):_vm._e(),_vm._v(" "),(_vm.from === 'Demandes')?_c('b-button',{staticClass:"float-right mb-3 btn-resultats rad btn btn-secondary",on:{"click":_vm.$parent.runExport}},[_vm._v("\n      Exporter les analyses\n    ")]):_vm._e(),_vm._v(" "),(
        _vm.from === 'Resultats' &&
        _vm.$parent.tri != 'analyseRadio' &&
        _vm.$parent.tri != 'productRadio' &&
        !this.$parent.radioSynthese
      )?_c('b-button',{staticClass:"float-right mb-3 btn-resultats rad btn btn-secondary",on:{"click":_vm.$parent.runExport}},[_vm._v("\n      Exporter les résultats\n    ")]):_vm._e(),_vm._v(" "),(_vm.from === 'Demandes')?_c('b-button',{staticClass:"button_ajout_style float-right mr-3 mb-3",on:{"click":function($event){return _vm.$parent.showModal('create')}}},[_vm._v("\n      Ajout Echantillon\n    ")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',[_c('div',{staticClass:"d-flex flex-column"},[_c('HeaderSearch',{attrs:{"from":"Demandes"},on:{"sac-customer-selected":_vm.onSacCustomerSelected}})],1),_vm._v(" "),_c('div',{staticClass:"font_size_0_7"},[_c('b-table',{attrs:{"responsive":"","hover":"","striped":"","items":_vm.items,"fields":_vm.fields,"busy":_vm.isBusy,"show-empty":"","emptyText":"Il n'y a pas d'échantillon"},scopedSlots:_vm._u([{key:"cell(CENT_TYP)",fn:function(data){return [(data.item.CENT_TYP === 2)?_c('span',[_vm._v(" DLC ")]):(data.item.CENT_TYP === 3)?_c('span',[_vm._v(" J+ ")]):_c('span',[_vm._v(" Jour ")])]}},{key:"cell(EDIT)",fn:function(data){return [(data.item.CENT_ECH == null)?_c('b-button',{staticClass:"font_size_0_7",attrs:{"size":"sm","variant":"outline-primary"},on:{"click":function($event){return _vm.showModal('edit', data)}}},[_vm._v("\n            Modifier\n          ")]):_vm._e()]}},{key:"cell(DELETE)",fn:function(data){return [(data.item.CENT_ECH == null)?_c('b-button',{staticClass:"font_size_0_7",attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){return _vm.showModalDelete(data)}}},[_vm._v("\n            Supprimer\n          ")]):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle color_green_labco",attrs:{"type":"grow"}})],1)]),_vm._v(" "),(_vm.items != null && _vm.totalItems > _vm.perPage)?_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-pagination',{attrs:{"total-rows":_vm.totalItems,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"my-modal",attrs:{"id":"modelStep","size":"xl","hide-footer":"","no-close-on-backdrop":"","title":_vm.titleModalForm},on:{"closeModel":_vm.hideModel,"hidden":_vm.hiddenModal}},[_c('DetailEchantillonComponent',{attrs:{"itemsAnalyse":_vm.items,"modeEdition":_vm.modeEdition,"itemEdit":_vm.itemEdit,"numRapport":_vm.items}})],1),_vm._v(" "),(_vm.itemToDelete != null)?_c('b-modal',{attrs:{"scrollable":"","size":"lg","title":"Voulez-vous vraiment supprimer cette analyse ?"},scopedSlots:_vm._u([{key:"modal-footer",fn:function(){return [_c('b-button',{staticClass:"float-right",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){_vm.modalDeleteShown = false}}},[_vm._v("\n          Annuler\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"float-right",attrs:{"variant":"danger","size":"sm"},on:{"click":_vm.deleteEchantillon}},[_vm._v("\n          Oui, effacer\n        ")])]},proxy:true}],null,false,966559785),model:{value:(_vm.modalDeleteShown),callback:function ($$v) {_vm.modalDeleteShown=$$v},expression:"modalDeleteShown"}},[_c('b',[_vm._v(_vm._s(_vm.itemToDelete.CENT_LIB))]),_c('br'),_vm._v(" "),_c('small',[_vm._v("Date de prélèvement : "+_vm._s(_vm.itemToDelete.CENT_DATPRLT)),_c('br'),_vm._v("\n        Date souhaitée : "+_vm._s(_vm.itemToDelete.CENT_DATSOUHAIT))]),_vm._v(" "),_vm._l((_vm.msgsErrorDelete),function(error,i){return [_c('b-alert',{key:i,staticClass:"mt-2",attrs:{"show":"","variant":"warning"},domProps:{"innerHTML":_vm._s(error.message)}})]}),_vm._v(" "),(_vm.msgSuccessDelete != '')?[_c('b-alert',{staticClass:"mt-2",attrs:{"show":"","variant":"success"},domProps:{"innerHTML":_vm._s(_vm.msgSuccessDelete)}})]:_vm._e()],2):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultatsComponent_vue__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45285910_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultatsComponent_vue__ = __webpack_require__(634);
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultatsComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45285910_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultatsComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 627:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SyntheseComponent_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3976c5f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SyntheseComponent_vue__ = __webpack_require__(633);
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SyntheseComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3976c5f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SyntheseComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-5"},[_c('b-row',[_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('b-form-group',[_vm._v("\n        Date de début\n        "),_c('b-form-input',{attrs:{"onfocus":"(this.type='date')","onBlur":"(this.type='text')","size":"sm","placeholder":"Date d'enregistrement","type":"text","state":_vm.dateDebut === null ? null : _vm.dateDebut != ''},model:{value:(_vm.dateDebut),callback:function ($$v) {_vm.dateDebut=$$v},expression:"dateDebut"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"6"}},[_c('b-form-group',[_vm._v("\n        Date de fin\n        "),_c('b-form-input',{attrs:{"onfocus":"(this.type='date')","onBlur":"(this.type='text')","size":"sm","placeholder":"Date d'enregistrement","type":"text","max":_vm.dateMax,"state":_vm.dateFin === null ? null : _vm.dateFin != ''},model:{value:(_vm.dateFin),callback:function ($$v) {_vm.dateFin=$$v},expression:"dateFin"}})],1)],1),_vm._v(" "),(_vm.msgNoSelected != '')?_c('b-col',{attrs:{"md":"12","lg":"12"}},[_c('b-alert',{staticClass:"mt-2",attrs:{"show":"","variant":"warning"}},[_vm._v(_vm._s(_vm.msgNoSelected))])],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","responsive":"","stacked":"true","items":_vm.analyses,"fields":_vm.fields,"selectable":"","select-mode":"single","selectedVariant":"success"},on:{"row-selected":_vm.selectAnalyse}},[_c('div',{staticClass:"text-center",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle color_green_labco",attrs:{"type":"grow"}})],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-table',{attrs:{"striped":"","hover":"","bordered":"","responsive":"","stacked":"true","items":_vm.analysesSelected,"fields":_vm.fieldsSelected}},[_c('div',{staticClass:"text-center",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle color_green_labco",attrs:{"type":"grow"}})],1)])],1),_vm._v(" "),(_vm.msgsErrorSave.length > 0)?_c('b-col',{attrs:{"md":"12","lg":"12"}},[_vm._l((_vm.msgsErrorSave),function(error,i){return [_c('b-col',{key:i},[_c('b-alert',{staticClass:"mt-2",attrs:{"show":"","variant":"danger"},domProps:{"innerHTML":_vm._s(error.message)}})],1)]})],2):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"12","lg":"12"}},[_c('b-button',{staticClass:"float-right mb-3",attrs:{"variant":"success"},on:{"click":_vm.exportCSV}},[_vm._v("Exporter la synthèse")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',[_c('div',{staticClass:"d-flex flex-column"},[_c('HeaderSearch',{attrs:{"from":"Resultats"}}),_vm._v(" "),(!_vm.radioSynthese)?_c('b-col',[_c('div',[_c('b-col',{attrs:{"md":"12"}},[(_vm.disablePagination === false)?_c('b-pagination',{attrs:{"total-rows":_vm.totalItems,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()],1),_vm._v(" "),_c('b-table',{class:("font_size_0_7 " + (_vm.tri !== 'resultatsRadio' ? 'tr-click' : '')),attrs:{"striped":"","hover":"","responsive":"","items":_vm.results,"fields":_vm.fields,"busy":_vm.isBusy,"outlined":"","show-empty":"","emptyText":"Il n'y a aucun résultat"},on:{"row-clicked":_vm.rowSelected}},[_c('div',{staticClass:"text-center",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align- middle color_green_labco",attrs:{"type":"grow"}})],1)]),_vm._v(" "),(
              _vm.disablePagination === false &&
              _vm.results != null &&
              _vm.totalItems > _vm.perPage
            )?_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[(_vm.tri !== 'analyseRadio')?_c('b-pagination',{attrs:{"total-rows":_vm.totalItems,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()],1)],1):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.radioSynthese)?_c('SyntheseComponent'):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"modalDetail",attrs:{"scrollable":"","title":_vm.modalTitle,"size":"xl"},on:{"hidden":_vm.modalHidden}},[(_vm.echantillonDiplayResult)?_c('h6',[_vm._v("\n        Echantillon N° "+_vm._s(_vm.idEchantillon)+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',[_c('b-table',{class:("font_size_0_7 " + (_vm.idEchantillon === null ? 'tr-click' : '')),attrs:{"striped":"","hover":"","items":_vm.modalResults,"fields":_vm.modalFieldsFor,"busy":_vm.modalIsBusySpinner,"outlined":"","show-empty":"","emptyText":"Il n'y a aucun résultat"},on:{"row-clicked":_vm.modalShowOneEchantillon},scopedSlots:_vm._u([{key:"cell(COMMENTAIRES)",fn:function(data){return [(data.item.COMMENTAIRES.length > 0)?_c('ul',_vm._l((data.item.COMMENTAIRES),function(com){return _c('li',{key:com},[_vm._v("\n                "+_vm._s(com)+"\n              ")])}),0):_vm._e()]}}])},[_c('div',{staticClass:"text-center",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle color_green_labco",attrs:{"type":"grow"}})],1)]),_vm._v(" "),(_vm.modalComments != null && _vm.tri == 'echantillonsRadio')?_c('ul',_vm._l((_vm.modalComments),function(com){return _c('li',{key:com.CECH_LIG},[_vm._v("\n            "+_vm._s(com.CECH_LIG)+"\n          ")])}),0):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w-100 text-right",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[(_vm.modalBtnPrec)?_c('b-button',{staticClass:"float-left",on:{"click":_vm.modalPrec}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}}),_vm._v("\n          Précédent\n        ")]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"mb-4",on:{"click":_vm.modalExportData}},[_vm._v("Exporter les données")]),_vm._v(" "),_c('b-button',{staticClass:"mb-4",attrs:{"variant":"success"},on:{"click":_vm.modalHide}},[_vm._v("OK")])],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(488);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e4b2da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(647);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e4b2da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 636:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__(489);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6b1972_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(646);
function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6b1972_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 638:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-auth"},[(_vm.showInputLocal.login)?_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"N° client"}},[_c('b-form-input',{ref:"login",attrs:{"type":"number","autocomplete":"off","required":"","min":"0","trim":""},on:{"input":function($event){_vm.warning = false}},model:{value:(_vm.value.login),callback:function ($$v) {_vm.$set(_vm.value, "login", $$v)},expression:"value.login"}})],1):_vm._e(),_vm._v(" "),(_vm.showInputLocal.correspondant)?_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"N° correspondant"}},[_c('b-form-input',{ref:"correspondant",attrs:{"type":"number","autocomplete":"off","required":"","min":"0","trim":""},model:{value:(_vm.value.correspondant),callback:function ($$v) {_vm.$set(_vm.value, "correspondant", $$v)},expression:"value.correspondant"}})],1):_vm._e(),_vm._v(" "),(_vm.showInputLocal.password)?_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Mot de passe"}},[_c('b-form-input',{ref:"password",attrs:{"type":"password","required":""},model:{value:(_vm.value.password),callback:function ($$v) {_vm.$set(_vm.value, "password", $$v)},expression:"value.password"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalForgetPassword_vue__ = __webpack_require__(491);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f574c6a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalForgetPassword_vue__ = __webpack_require__(643);
function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var normalizeComponent = __webpack_require__(29)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalForgetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f574c6a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalForgetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 642:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modalForgetPassword",staticClass:"modal-forget-password",attrs:{"title":"Mot de passe oublié ?"},on:{"ok":_vm.forgetPasswordOk,"show":_vm.initModal},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
return [_c('b-button',{staticClass:"button-color",on:{"click":_vm.hide}},[_vm._v("Annuler")]),_vm._v(" "),_c('b-button',{staticClass:"button-color",attrs:{"disabled":!_vm.checkFormValidity,"variant":"success"},on:{"click":ok}},[_vm._v("\n      Valider\n    ")])]}}])},[_c('b-form',{ref:"forgetPasswordForm",on:{"submit":_vm.forgetPasswordOnSubmit}},[_c('form-auth',{ref:"formAuth",attrs:{"showInput":{ password: false }},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modalUpdatePassword",attrs:{"id":"modalUpdatePassword","no-close-on-backdrop":""},on:{"show":_vm.initModal,"hidden":_vm.hidden,"ok":_vm.handleOk},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]},proxy:true},{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
return [_c('b-button',{on:{"click":_vm.hide}},[_vm._v(" Annuler ")]),_vm._v(" "),_c('b-button',{attrs:{"disabled":!_vm.checkFormValidity,"variant":"success"},on:{"click":ok}},[_vm._v("\n      Valider\n    ")])]}}])},[_vm._v(" "),(_vm.message)?_c('b-alert',{attrs:{"show":""}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]):_vm._e(),_vm._v(" "),_c('b-form',{ref:"formUpdatePassword",on:{"submit":function($event){$event.preventDefault();return _vm.updatePassword($event)}}},[_c('form-auth',{ref:"formAuth",attrs:{"showInput":_vm.showInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Nouveau mot de passe"}},[_c('b-form-input',{ref:"passwordNew",attrs:{"type":"password","autocomplete":"off","state":_vm.passwordNewValide,"required":""},model:{value:(_vm.passwordNew),callback:function ($$v) {_vm.passwordNew=$$v},expression:"passwordNew"}}),_vm._v(" "),_c('b-form-text',[_vm._v("\n        Le mot de passe doit comporter au minimum :\n        "),_c('ul',[_c('li',[_vm._v("\n            8 caractères\n            "),(_vm.checkConstrainteLen)?_c('i',{staticClass:"fa fa-check text-success",attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('li',[_vm._v("\n            Un chiffre : 0-9\n            "),(_vm.checkConstrainteNumber)?_c('i',{staticClass:"fa fa-check text-success",attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('li',[_vm._v("\n            Une majuscule : A-Z\n            "),(_vm.checkConstrainteMajuscule)?_c('i',{staticClass:"fa fa-check text-success",attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('li',[_vm._v("\n            Une minuscule : a-z\n            "),(_vm.checkConstrainteMinuscule)?_c('i',{staticClass:"fa fa-check text-success",attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('li',[_vm._v("\n            Un caractère spécial : #$%&@^`~*+!?={[()]}\n            "),(_vm.checkConstrainteSpecialChar)?_c('i',{staticClass:"fa fa-check text-success",attrs:{"aria-hidden":"true"}}):_vm._e()])])])],1),_vm._v(" "),_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Confirmez votre nouveau mot de passe"}},[_c('b-form-input',{attrs:{"type":"password","autocomplete":"off","state":_vm.passwordNewBisValide,"required":""},model:{value:(_vm.passwordNewBis),callback:function ($$v) {_vm.passwordNewBis=$$v},expression:"passwordNewBis"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"auth"},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('b-form-row',[_c('b-col',{attrs:{"offset":"0","cols":"6"}},[_c('form-auth',{ref:"formAuth",model:{value:(_vm.dataAuth),callback:function ($$v) {_vm.dataAuth=$$v},expression:"dataAuth"}}),_vm._v(" "),_c('div',{staticClass:"forgetpassword mb-3"},[_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.modalForgetPassword}},[_vm._v("\n            Mot de passe oublié ?\n          ")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"mb-1 btn-login"},[_c('b-button',{staticClass:"pull-center btn-connexion",attrs:{"type":"submit","block":"","variant":"success"}},[_vm._v("Connexion\n            "),(_vm.authLoad)?_c('i',{staticClass:"fa fa-spinner fa-pulse fa-fw"}):_vm._e()])],1)],1)],1)],1),_vm._v(" "),_c('modal-forget-password',{ref:"modalForgetPassword",model:{value:(_vm.dataAuth),callback:function ($$v) {_vm.dataAuth=$$v},expression:"dataAuth"}}),_vm._v(" "),_c('modal-update-password',{ref:"modalUpdatePassword",attrs:{"upgradePassword":_vm.upgradePassword},model:{value:(_vm.dataAuth),callback:function ($$v) {_vm.dataAuth=$$v},expression:"dataAuth"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$root.user)?_c('div',{staticStyle:{"padding-bottom":"4rem"}},[_c('b-navbar',{attrs:{"toggleable":"lg","variant":"light","type":"light"}},[_c('b-navbar-nav',{staticClass:"display_none_sm no-border aaaaa "},[_c('b-nav-item',{staticClass:"labco_color mr-2",attrs:{"exact-active-class":"active_item","to":"/"}},[_c('img',{staticClass:"logo_fix",attrs:{"src":__webpack_require__(178),"height":"40"}})])],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"display_none_lg"},[_c('b-nav-item',{staticClass:"labco_color",attrs:{"exact-active-class":"active_item","to":"/"}},[_c('img',{staticClass:"mb-2",attrs:{"src":__webpack_require__(178),"height":"50"}})])],1),_vm._v(" "),_c('h6',{staticClass:"mt-3 user_info_fix labco_color"},[_vm._v("\n        Bienvenue sur votre espace :"),_c('br'),_vm._v(_vm._s(_vm.$root.user.rso)),_c('br'),_vm._v(_vm._s(_vm._f("capitalize")(_vm.$root.user.nom))+"\n      ")]),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',{staticClass:"border-left"},[_c('b-nav-item',{staticClass:"labco_color",attrs:{"exact-active-class":"active_item","to":"/Resultats"}},[_vm._v("\n            Résultats\n          ")])],1),_vm._v(" "),_c('b-navbar-nav',[(_vm.$root.user.roles.ENREG === 1)?_c('b-nav-item',{staticClass:"labco_color",attrs:{"exact-active-class":"active_item","to":"/Demande/Nouvelle"}},[_vm._v("\n            Demandes d'analyses\n          ")]):_vm._e()],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"display_none_sm no-border"},[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"ml-2 mr-2",attrs:{"title":"Site vitrine","href":"http://www.laboratoire-labco.com/","target":"blank"}},[_c('img',{staticClass:"iconav",attrs:{"src":__webpack_require__(648)}})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"b-modal",rawName:"v-b-modal.modalUpdatePassword",modifiers:{"modalUpdatePassword":true}}],staticClass:"mr-2",attrs:{"title":"Modification de votre mot de passe","href":"#"}},[_c('img',{staticClass:"iconav",attrs:{"src":__webpack_require__(649)}})]),_vm._v(" "),_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Se déconnecter","href":"#"},on:{"click":_vm.disconnect}},[_c('img',{staticClass:"iconav",attrs:{"src":__webpack_require__(650)}})])]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto display_none_lg"},[_c('b-nav-item',{staticClass:"labco_color",on:{"click":_vm.disconnect}},[_vm._v("\n            Déconnexion\n          ")])],1)],1)],1),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('b-navbar',{staticStyle:{"height":"1rem","min-width":"300px","padding":"2rem"},attrs:{"variant":"light","type":"light","fixed":"bottom"}},[_c('ul',{staticClass:"navbar-nav border-left"},[_c('li',{staticClass:"nav-item labco_color"},[_c('a',{staticClass:"nav-link",attrs:{"target":"blank","href":"https://alco.info/doc/Procedure_Gestion_Reclamations.pdf"}},[_vm._v("Procédure de Gestion de Réclamation")])]),_vm._v(" "),_c('li',{staticClass:"nav-item border-left labco_color"},[_c('a',{staticClass:"nav-link",attrs:{"target":"blank","href":"https://alco.info/doc/Catalogue_analytique.pdf"}},[_vm._v("Catalogue analytique")])]),_vm._v(" "),_c('li',{staticClass:"nav-item border-left labco_color"},[_c('a',{staticClass:"nav-link",attrs:{"target":"blank","href":"https://alco.info/doc/preparation_des_fromages.pdf"}},[_vm._v("Préparation des fromages")])])])]),_vm._v(" "),_c('modal-update-password',{model:{value:(_vm.$root.user),callback:function ($$v) {_vm.$set(_vm.$root, "user", $$v)},expression:"$root.user"}})],1):_c('b-container',{staticClass:"form_login"},[_c('div',{staticClass:"imgLog"},[_c('img',{attrs:{"src":__webpack_require__(178)}})]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"padding_0"},[_c('img',{staticClass:"barreLog",attrs:{"src":__webpack_require__(651)}}),_vm._v(" "),_c('b-card',{staticClass:"login_card"},[_c('h1',[_vm._v("\n            Avec l'application du LABCO "),_c('br'),_vm._v("\n            consultez et créez vos demandes "),_c('br'),_vm._v("\n            d'analyses.\n          ")]),_vm._v(" "),_c('auth'),_vm._v(" "),(_vm.showMaintenanceMessage)?_c('div',{staticClass:"alert alert-warning alert-dismissible fade show mt-5",staticStyle:{"max-width":"500px","margin":"0 auto"},attrs:{"role":"alert"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("⚠️ Maintenance programmée")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Chers clients,")]),_c('br'),_vm._v("\n              Nous vous informons que nos sites internet seront temporairement indisponibles en raison d'une opération de maintenance programmée le "),_c('strong',[_vm._v("jeudi 7 août 2025, de 09h00 à 12h00")]),_vm._v(".")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Cette intervention vise à améliorer la qualité et la sécurité de nos services. Nous vous prions de bien vouloir nous excuser pour la gêne occasionnée et vous remercions de votre compréhension."),_c('br'),_c('br'),_vm._v(" "),_c('em',[_vm._v("Cordialement, L'équipe informatique ALCO")])])]):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAsCAYAAAD8WEF4AAAACXBIWXMAAAsSAAALEgHS3X78AAAD1ElEQVRYhdWZSUwTURjH/3RjgAJFWspuixILomAE4oIBYkiUYOBg5Opd7171rsaDJN70qic96EkFIxxcDiAKJJACFlmLtNCylM18I9PUPqbMCvhLJqTfvDf85ps3b5uk7e1tCHR09rgAuHA4CNxqvNgba8LLdnT2VAF4BKD+kIgKBMnrVuPFu/Tb6KhvItEuACeYogcPB6Dhy5gvqdZd3JX0+H33SwCth1A0HrfhPxElGgxMSCXpXDIKbJn8X41xmbS4Hsl58nJQYs+GxWT859yo/zf6fJP4FQgy9eSiSjbZZEKNuwiVhfnMOQG3/Qh/TAaCeNM/hLWNDaaMVBQ3AxJtO1ORUDSWfFsmX57q7btsXakbdmsaE08Elb9WdRIbW1sJSomjSJZvo7k5TFwKznQr8hzZ6J9fgC8UxurmpuS6ip5JZZG0Ry9G4zEXXnwbgH91FSPBRXBGI+wpHLKSLbBznEgthbL0wqjBkZYKV5YNYwsB/iqU3YlQmD8IErYlW+BI4fgbUSxLTUALKpyOqGw8lPH4rNssllxN+lklpFrMkmoJWY+kbHo0H8H0RLasmk49FrEmkAjZsn56JBvSuxsxxhbkD7+KmkHfxCQTk8PAzBxmd958/WV9k6qy+/zbABOTgiJZarfvBoeZuBReDw3jx8zc/skSXv+8bOEu7ziefu1j4lJR1c8OTc9iaimEutISuLLEB4u58DKefu3FZ5+6tq56UAiGl3G/sxsnnQ6cLcxHbro1es4XWET/9CzeeseYekrQZAQry7JhK7KOL95x5hxxKc+J0aVQdOxXyr6MYCaDAaWZGfxNqboOE5EBzfppBlbiyOYXiPGTcere/KEQfgUW4Z2bj8YHFYxeimVJrNZdvOcEnBaPtJyho8ZVhKXVNXwe/Ymp78sIrEWY8prKUiZpOaN0lUA3ebmslF9kPvj4SXZ/K7nN0iNur6lSLBpLBsfhXlM9bpwuZ84lQlJmSZAyojUkm2NN4/vgcGR9z6vvmVm9RAUaSo7iTv0FJr4bCWVpCaOnqEC504HbF2qYeDyisvQyNZ8qY+J6QRlu8SROjKhs8ykPs2+lNzerK/k2LMaustRO8zVaxcrl9vlq0Rq7ylKHf1BQ+6VJ0W4wspRVHfZWZdEu0v8ysgeZVQGx7P4jS6PUQWdVgPbDYjEmGUZI9pUQo93rw0Jt3Oaf2Wh4RrJ3d743abaPpQWpZjO/eYe/G3W9D1uvdBt2vuI1cGaTT+7msN6cKy5ATgr34cn1ljP0r+I/h9IHPEnT+cXIunVmZeW4nr6P2q7SV8+/APgDZLwW92GhlaAAAAAASUVORK5CYII="

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAAsSAAALEgHS3X78AAADPUlEQVRYhe2ZPUwUQRTH/zO7dxwKHAkkFiaiaCHGoJWx0fiV0NiYiJWG+BFtKLAXpdNCExJpKPwqaEwMFljQGExMpDAxGqMFkXi5ADECOfm4447dGTMrdwFmd252joMj8dftu5nd3+29nfd2jnDOsdTXtBdAD4AOVBYJAF2xzsRrYUUyj/fUA/gJIF5hoqu5GutMPKcAeitcFCuO3p0Vd7VJ+rjyOE23iagHlSIVzH/ZcrGtZG0pUgT7yHWgqs4bxMaHwaa/qSeswmpuA2k8BDL2GTzxASyaBYsxaVwQoWQj5x7BOnixcMyb25AbvASenZPGSqIt7Yicffjv4BjAX9yC9fWt99sKYVbNwGIc3ObS3DzaabBeVEAaWxC98BJk5U4HsUY0P7ejHzh8BmAATVPYMzaiExFEpyKwZy2QHJHOpiVLdx+XRHWF/UTXCO9rXRvLEVjzliddlYx6X8JaoCBZUrMhD1iQsEq0wK79UqgAgyfqCS/SA1qyZH4GmPwuxVXCWqKCbFoKBaEl686NgQ3c1BYWK4aW6OgA8GlYCgehnQbLkSTYs2tARv3kC2H7xF0pLjE6AP6qRwqr0JYVS4pLfoH3ni8qXA5RhK1gbp0Llp4sTdhQFCbl1mlwgNSUmfBIv7EoTGRFOjhxF5gNJywqFn+j8dApMFpnvXSIBZfFcmFeFNp7QLqGgGr/yrWeQnktASNZr09ovawtmqdU4dCyfg1NGEoRDiVbqmgeU+GSWkQ/vKf+/snilc5AWEtW1HpdUYiGWnNZ82sRVejd2YBe1Vc0j+46rGoR16HXIk6MKS8qiYYR3ugWcTk5BPbkiu9FA0XzqITL0iJSwFn6Il20qKhK2KChERtz2nVTvMhZTh14TRxYzoGkpqUxSqp3Gs91a93boV7FnXoXdGoB5Pei9JkWmUWQjOHc0BVMpEODK4U3i9DlVmxIuLVbI2zUyIh0UO2clAuzFnGL0oGu/CMSmq1IByE7IkU12bR0oOCgGBSyXQD+SAP0TrIp6eDuYE/tO+MJGutMpAAcBfBOGqVBOdOBW9xxa9kD+96PG+LY+4dxNUt9TafCnlTs8ImNsw01Jfhod4+/LxwD+AuPM1m+OBkvYAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAe+CAMAAACy+l2aAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADNQTFRF+a5W+Jos/vjx/vHj+9Cc/evV+rVl/N24+8mO+adI+KE6+8KB/eTH+rxz95Me////////jmtjOQAAABF0Uk5T/////////////////////wAlrZliAAAE/0lEQVR42uzbXZLiRhCFURojQIA1vf/V2uP5o7sBVZbqPjjisIDz8AUBUlbW7tv9533YZ8flcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrmP3Cnk7qaQO4fc5RxylynkziG3t8Sq21li3Z1D7nIIuW9/ZdxlF3J7SjS5HSWa3I4SbW69RKNbLtHolku0utUSzW6xRLNbLNHu1koU3FKJglsqUXGXU8h922fc5Rhy20sU3eYSRbe5RNVtLVF2G0uU3cYSdbetRIfbVKLDbSrR47aU6HIbSnS5y98hd7mF3Ms+4y7XkLtWottdKdHtrpTod1+X2OC+LLHBfVlii/uqxCb3RYlN7osS29znJTa6l5D7dIyw1X02RtjsziH3SYnt7uMSA9w55D4sMcJ9VGKIO4fcByXGuF9LDHLnkPulxCj3c4lh7i7kfhojjHM/jhHGuR9LDHQ/lBjp3pcY6d6XGOrelRjr/ikx1v1TYrD7u8Ro91eJ0e6vEsPdnyXGuz9KjHd/jBEC7n9jhIT7fYyQcL+XiLj/lsi4b/uMuxxD7hJy55A7Zdxz5vswh76/U8Y9Z34f5tDv2ZRxr5n/i58zlOHuLfO/ec08P/yeJA12b5nnqGvmefJunjbUvWWeq6+Z94sPU8WB7inznnXMvG9+OoMZ5p4y793HzPzhy0nUIPeUmcMcM/OoB+dxQ9xTZi53zMwnH+5xDHAPmTntLjOvfrLNstk9ZOb2u8z5xdOdno3uIXOOs8ucZ73YbNrkHjLnhXPofHPKuOfM+fEcOu+eMu45s0+wtm3c604Zd3Wbu89d37nuc6eMe32PuJd9xr29R9yGCj3uZZ9xWyp0uE0V6u5ln3HbKpTdxgpV97LPuO2LxSW3ff235BbWlUtuYb264hYqVNxKhYpbqVBwSxXa3VqFdrdWodktVmh16xd92tz6xaQmt+MiVYvbc/Grxe25qNbg9lwna3C7rr81uF3X9dbdrgrrbl+FdbevwqrbWWHVnTJu93Xe124/6z46l8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLpfL5XK5XC6Xy+VyuVwul8vlcrlcLvd/5f4jwABBNHrshxtlNwAAAABJRU5ErkJggg=="

/***/ })

},[494]);


// WEBPACK FOOTER //
// static/js/app.d2ae333a0e85b64f73e4.js